'use strict';
import AWN from 'awesome-notifications';

(function () {
    if (typeof window !== 'undefined') {
        window.__khProjectsBundleActive = true;
    }

    var initProjectsPage = function () {
    var pageRoot = document.getElementById('page-innohub-my-projects') || document.getElementById('kh-home-projects');
    if (!pageRoot) {
        return;
    }

    var configNode = document.getElementById('kh-projects-config') || document.getElementById('kh-home-projects-config');
    if (!configNode) {
        return;
    }

    var config = {};
    try {
        config = JSON.parse(String(configNode.textContent || '{}'));
    } catch (e) {
        config = {};
    }

    var i18n = config.i18n && typeof config.i18n === 'object' ? config.i18n : {};
    var t = function (key, fallback) {
        if (Object.prototype.hasOwnProperty.call(i18n, key) && String(i18n[key] || '') !== '') {
            return String(i18n[key]);
        }
        return fallback;
    };

    var context = String(config.context || '').trim().toLowerCase();
    var projectId = parseInt(config.projectId || 0, 10) || 0;
    var currentUserId = String(config.currentUserId || '').trim();
    var currentUserEmail = String(config.currentUserEmail || '').trim().toLowerCase();
    var baseEndpoint = String(config.baseEndpoint || '');
    var projectBaseEndpoint = String(config.projectBaseEndpoint || '').trim();
    var projectsEndpoint = String(config.projectsEndpoint || '');
    var bearerToken = String(config.bearerToken || '');
    var methodEditorBaseUrl = String(config.methodEditorBaseUrl || '').trim();
    var storageBaseUrl = String(config.storageBaseUrl || '').trim();
    var canDeleteProjectFiles = !!config.canDeleteProjectFiles;
    var canManageProjectRoles = !!config.canManageProjectRoles;
    var currentProjectRole = String(config.currentProjectRole || '').trim();
    var apiOrigin = '';
    try {
        apiOrigin = baseEndpoint ? new URL(baseEndpoint, window.location.origin).origin : window.location.origin;
    } catch (e) {
        apiOrigin = window.location.origin;
    }
    var postUrl = String(config.postUrl || window.location.href);
    var projectPageUrl = String(config.projectPageUrl || postUrl || window.location.href);
    var listUrl = String(config.listUrl || window.location.href);
    var homeLatestProjectsLimit = parseInt(config.homeLatestProjectsLimit || 3, 10) || 3;
    var searchDebounceMs = parseInt(config.searchDebounceMs || 300, 10) || 300;
    var minSearchChars = parseInt(config.minSearchChars || 2, 10) || 2;
    var searchTimer = null;
    var projectSearchTimer = null;
    var lastSearchQuery = '';
    var methodsCache = [];
    var projectsCache = Array.isArray(config.initialProjects) ? config.initialProjects : [];
    var projectsLoadedOnce = projectsCache.length > 0;
    var projectsFetchPromise = null;
    var initialProjectMethods = Array.isArray(config.initialProjectMethods) ? config.initialProjectMethods : [];
    var currentMethod = null;
    var currentResult = null;
    var resultsCache = [];
    var membersCache = [];
    var editorDirty = false;
    var editorReadOnly = false;
    var formState = {};
    var fieldErrors = {};
    var pendingUploads = 0;
    var syncTemplateBeforeSave = null;

    var openBtn = document.getElementById('kh-open-create-modal');
    var closeBtn = document.getElementById('kh-close-create-modal');
    var createModal = document.getElementById('kh-create-project-modal');
    var createProjectFormEl = document.getElementById('kh-create-project-form');
    var createProjectSubmitEl = document.getElementById('kh-create-project-submit');
    var openSettingsBtn = document.getElementById('kh-open-settings-modal');
    var closeSettingsBtn = document.getElementById('kh-close-settings-modal');
    var settingsModal = document.getElementById('kh-project-settings-modal');
    var resultModal = document.getElementById('kh-result-editor-modal');
    var settingsTabsEl = document.getElementById('kh-settings-tabs');
    var settingsSaveActiveBtn = document.getElementById('kh-settings-save-active');

    var contentSearchForm = document.getElementById('kh-content-search-form');
    var contentSearchInput = document.getElementById('kh-content-search-input');
    var contentSearchResultsEl = document.getElementById('kh-content-search-results');
    var projectSearchForm = document.getElementById('kh-project-search-form');
    var projectSearchInput = document.getElementById('kh-project-search-input');
    var projectListEl = document.getElementById('kh-project-list');
    var homeProjectListEl = document.getElementById('kh-home-project-list');
    var homeProjectInvitesSectionEl = document.getElementById('kh-home-project-invites');
    var homeProjectInvitesListEl = document.getElementById('kh-home-project-invites-list');
    var projectFilesFormEl = document.getElementById('kh-project-files-form');
    var projectFileInputEl = document.getElementById('kh-project-file-input');
    var projectFileMethodSelectEl = document.getElementById('kh-project-file-method');
    var projectFilesSubmitEl = document.getElementById('kh-project-files-submit');
    var projectFilesListEl = document.getElementById('kh-project-files-list');
    var projectFilesTypeFilterEl = document.getElementById('kh-project-files-type-filter');
    var settingsProjectFilesListEl = document.getElementById('kh-settings-project-files-list');
    var projectCommentFormEl = document.getElementById('kh-project-comment-form');
    var projectCoverWrapEl = document.getElementById('kh-project-cover-wrap');
    var projectCoverImageEl = document.getElementById('kh-project-cover-image');
    var settingsCoverPreviewEl = document.getElementById('kh-settings-cover-preview');
    var settingsCoverImageEl = document.getElementById('kh-settings-cover-image');
    var methodsListEl = document.getElementById('kh-project-methods-list');
    var resultsListEl = document.getElementById('kh-project-results-list');
    var resultsStatusFilterEl = document.getElementById('kh-project-results-status-filter');
    var contentMethodsListEl = document.getElementById('kh-content-methods-list');
    var commentsListEl = document.getElementById('kh-project-comments-list');
    var membersListEl = document.getElementById('kh-project-members-list');
    var projectNameEl = document.getElementById('kh-project-name');
    var projectDescriptionEl = document.getElementById('kh-project-description');
    var projectVisibilityEl = document.getElementById('kh-project-visibility');
    var projectRoleEl = document.getElementById('kh-project-role');
    var projectInviteBannerEl = document.getElementById('kh-project-invite-banner');
    var statsMembersEl = document.getElementById('kh-stat-members');
    var statsMethodsEl = document.getElementById('kh-stat-methods');
    var statsItemsEl = document.getElementById('kh-stat-items');

    var editorEl = document.getElementById('kh-method-editor');
    var editorTitleEl = document.getElementById('kh-method-editor-title');
    var editorStatusLineEl = document.getElementById('kh-method-editor-status-line');
    var editorErrorEl = document.getElementById('kh-method-editor-error');
    var editorCloseBtn = document.getElementById('kh-method-editor-close');
    var createResultBtn = document.getElementById('kh-project-result-create');
    var createResultHintEl = document.getElementById('kh-project-result-create-hint');
    var resultStatusEl = document.getElementById('kh-method-result-status');
    var resultTitleEl = document.getElementById('kh-method-result-title');
    var resultShortDescriptionEl = document.getElementById('kh-result-short-description');
    var resultDescriptionEl = document.getElementById('kh-result-description');
    var resultDescriptionToolbarEl = document.getElementById('kh-result-description-toolbar');
    var resultAssignedUserEl = document.getElementById('kh-result-assigned-user');
    var resultMethodsEl = document.getElementById('kh-result-methods');
    var resultFilesInputEl = document.getElementById('kh-result-files-input');
    var resultFilesListEl = document.getElementById('kh-result-files-list');
    var resultImageSelectEl = document.getElementById('kh-result-image-select');
    var resultImagePreviewEl = document.getElementById('kh-result-image-preview');
    var resultDeleteBtn = document.getElementById('kh-result-delete');
    var statusChipEl = document.getElementById('kh-method-status-chip');
    var templateSectionsEl = document.getElementById('kh-method-template-sections');
    var methodResourcesEl = null;
    var saveBtn = document.getElementById('kh-method-save');
    var loadingOverlayEl = document.getElementById('kh-projects-loading');
    var activeLoadingRequests = 0;
    var projectFilesCache = [];
    var projectLinksCache = [];
    var uploadAllowedExtensions = ['pdf', 'txt', 'docx', 'csv', 'xlsx', 'jpg', 'jpeg', 'png'];
    var uploadMaxBytes = 20 * 1024 * 1024;
    if (projectBaseEndpoint === '' && baseEndpoint) {
        projectBaseEndpoint = baseEndpoint.replace(/\/\d+\/?$/, '');
    }
    var notifier = new AWN({
        labels: {
            info: t('noticeInfo', 'Info'),
            success: t('noticeSuccess', 'Success'),
            warning: t('noticeWarning', 'Warning'),
            alert: t('noticeError', 'Error')
        }
    });

    var notify = function (type, message) {
        if (!message) {
            return;
        }
        if (type === 'success') {
            notifier.success(message, { durations: { global: 5000 } });
            return;
        }
        if (type === 'warning') {
            notifier.warning(message, { durations: { global: 5000 } });
            return;
        }
        if (type === 'info') {
            notifier.info(message, { durations: { global: 5000 } });
            return;
        }
        notifier.alert(message, { durations: { global: 5000 } });
    };

    var sanitizeLimitedHtml = function (html) {
        var source = String(html || '').trim();
        if (!source) {
            return '';
        }
        if (typeof window === 'undefined' || typeof window.DOMParser === 'undefined') {
            return source;
        }

        var allowedTags = {
            a: ['href', 'target', 'rel'],
            br: [],
            em: [],
            i: [],
            li: [],
            ol: [],
            p: [],
            strong: [],
            b: [],
            u: [],
            ul: []
        };

        var parser = new window.DOMParser();
        var doc = parser.parseFromString('<div>' + source + '</div>', 'text/html');
        var root = doc.body && doc.body.firstElementChild ? doc.body.firstElementChild : null;
        if (!root) {
            return source;
        }

        var rebuildNode = function (node, targetDoc) {
            if (!node) {
                return null;
            }
            if (node.nodeType === window.Node.TEXT_NODE) {
                return targetDoc.createTextNode(node.textContent || '');
            }
            if (node.nodeType !== window.Node.ELEMENT_NODE) {
                return null;
            }

            var tagName = String(node.tagName || '').toLowerCase();
            if (!Object.prototype.hasOwnProperty.call(allowedTags, tagName)) {
                var fragment = targetDoc.createDocumentFragment();
                Array.prototype.slice.call(node.childNodes || []).forEach(function (childNode) {
                    var rebuiltChild = rebuildNode(childNode, targetDoc);
                    if (rebuiltChild) {
                        fragment.appendChild(rebuiltChild);
                    }
                });
                return fragment;
            }

            var cleanNode = targetDoc.createElement(tagName);
            allowedTags[tagName].forEach(function (attrName) {
                if (!node.hasAttribute(attrName)) {
                    return;
                }
                var attrValue = String(node.getAttribute(attrName) || '').trim();
                if (!attrValue) {
                    return;
                }
                if (tagName === 'a' && attrName === 'href') {
                    if (/^(javascript|data):/i.test(attrValue)) {
                        return;
                    }
                }
                cleanNode.setAttribute(attrName, attrValue);
            });
            if (tagName === 'a' && cleanNode.hasAttribute('href')) {
                cleanNode.setAttribute('rel', 'noopener noreferrer');
            }

            Array.prototype.slice.call(node.childNodes || []).forEach(function (childNode) {
                var rebuiltChild = rebuildNode(childNode, targetDoc);
                if (rebuiltChild) {
                    cleanNode.appendChild(rebuiltChild);
                }
            });

            return cleanNode;
        };

        var container = document.createElement('div');
        Array.prototype.slice.call(root.childNodes || []).forEach(function (childNode) {
            var rebuiltChild = rebuildNode(childNode, document);
            if (rebuiltChild) {
                container.appendChild(rebuiltChild);
            }
        });
        return container.innerHTML;
    };

    var setLimitedHtml = function (element, html) {
        if (!element) {
            return;
        }
        element.innerHTML = sanitizeLimitedHtml(html);
    };

    var hasAssignedProjectMethods = function () {
        return Array.isArray(methodsCache) && methodsCache.length > 0;
    };

    var updateCreateResultButtonState = function () {
        var canCreateResult = hasAssignedProjectMethods();

        if (createResultBtn) {
            createResultBtn.disabled = !canCreateResult;
            if (canCreateResult) {
                createResultBtn.removeAttribute('title');
            } else {
                createResultBtn.setAttribute('title', t('resultNeedsProjectMethods', 'You can only create results once this project has at least one method.'));
            }
        }

        if (createResultHintEl) {
            createResultHintEl.textContent = t('resultNeedsProjectMethods', 'You can only create results once this project has at least one method.');
            createResultHintEl.style.display = canCreateResult ? 'none' : 'block';
        }
    };

    var buildFlashMessage = function (payload, fallback) {
        var flash = payload && payload.flash && typeof payload.flash === 'object' ? payload.flash : null;
        var title = flash && flash.title ? String(flash.title) : '';
        var detail = flash && flash.detail ? String(flash.detail) : '';

        if (title && detail) {
            return title + ' ' + detail;
        }
        if (title) {
            return title;
        }
        if (detail) {
            return detail;
        }
        if (payload && payload.message) {
            return String(payload.message);
        }
        return fallback;
    };

    var setLoadingOverlay = function (active) {
        if (!loadingOverlayEl) {
            return;
        }
        loadingOverlayEl.classList.toggle('is-active', active);
        loadingOverlayEl.setAttribute('aria-hidden', active ? 'false' : 'true');
    };

    var showLoadingOverlay = function () {
        activeLoadingRequests += 1;
        setLoadingOverlay(true);
    };

    var hideLoadingOverlay = function () {
        activeLoadingRequests = Math.max(0, activeLoadingRequests - 1);
        if (activeLoadingRequests === 0) {
            setLoadingOverlay(false);
        }
    };

    var openModal = function (targetModal, focusSelector) {
        if (!targetModal) {
            return;
        }
        targetModal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        if (!focusSelector) {
            return;
        }
        var focusEl = document.querySelector(focusSelector);
        if (focusEl) {
            focusEl.focus();
        }
    };

    var closeModal = function (targetModal) {
        if (!targetModal) {
            return;
        }
        targetModal.setAttribute('aria-hidden', 'true');
        if (
            (createModal && createModal.getAttribute('aria-hidden') === 'false') ||
            (settingsModal && settingsModal.getAttribute('aria-hidden') === 'false')
        ) {
            return;
        }
        document.body.style.overflow = '';
    };

    if (openBtn && closeBtn && createModal) {
        openBtn.addEventListener('click', function () {
            openModal(createModal, '#kh_modal_project_name');
        });
        closeBtn.addEventListener('click', function () {
            closeModal(createModal);
        });
        createModal.addEventListener('click', function (event) {
            if (event.target === createModal) {
                closeModal(createModal);
            }
        });
    }

    if (openSettingsBtn && closeSettingsBtn && settingsModal) {
        var getActiveSettingsForm = function () {
            var activePane = settingsModal.querySelector('.kh-settings-pane.is-active');
            return activePane ? activePane.querySelector('form') : null;
        };
        var updateSettingsSaveButton = function () {
            if (!settingsSaveActiveBtn) {
                return;
            }
            settingsSaveActiveBtn.hidden = !getActiveSettingsForm();
        };
        var activateSettingsTab = function (targetId) {
            var tabs = settingsTabsEl ? settingsTabsEl.querySelectorAll('.kh-settings-tab') : [];
            var panes = settingsModal.querySelectorAll('.kh-settings-pane');
            var nextId = String(targetId || '').trim();
            if (!nextId && tabs.length) {
                nextId = tabs[0].getAttribute('data-tab-target') || '';
            }
            tabs.forEach(function (tab) {
                var isActive = String(tab.getAttribute('data-tab-target') || '') === nextId;
                tab.classList.toggle('is-active', isActive);
            });
            panes.forEach(function (pane) {
                pane.classList.toggle('is-active', pane.id === nextId);
            });
            updateSettingsSaveButton();
        };
        if (settingsTabsEl) {
            settingsTabsEl.querySelectorAll('.kh-settings-tab').forEach(function (tab) {
                tab.addEventListener('click', function () {
                    activateSettingsTab(tab.getAttribute('data-tab-target'));
                });
            });
            activateSettingsTab('');
        }
        openSettingsBtn.addEventListener('click', function () {
            if (!canManageMembers()) {
                notify('alert', t('membersPermissionDenied', 'Only project owners and admins can manage members.'));
                return;
            }
            openModal(settingsModal, '#kh_settings_project_name');
            activateSettingsTab('');
        });
        closeSettingsBtn.addEventListener('click', function () {
            closeModal(settingsModal);
        });
        if (settingsSaveActiveBtn) {
            settingsSaveActiveBtn.addEventListener('click', function () {
                var activeForm = getActiveSettingsForm();
                if (!activeForm) {
                    return;
                }
                if (typeof activeForm.requestSubmit === 'function') {
                    activeForm.requestSubmit();
                    return;
                }
                activeForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
            });
        }
        settingsModal.addEventListener('click', function (event) {
            if (event.target === settingsModal) {
                closeModal(settingsModal);
            }
        });
    }

    if (resultModal) {
        resultModal.addEventListener('click', function (event) {
            if (event.target === resultModal) {
                closeEditor(true);
            }
        });
    }

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
            return;
        }
        if (createModal && createModal.getAttribute('aria-hidden') === 'false') {
            closeModal(createModal);
        }
        if (settingsModal && settingsModal.getAttribute('aria-hidden') === 'false') {
            closeModal(settingsModal);
        }
        if (resultModal && resultModal.getAttribute('aria-hidden') === 'false') {
            closeEditor(true);
        }
    });

    var extractRows = function (payload) {
        if (Array.isArray(payload)) {
            return payload;
        }
        if (payload && Array.isArray(payload.data)) {
            return payload.data;
        }
        if (payload && payload.data && Array.isArray(payload.data.data)) {
            return payload.data.data;
        }
        return [];
    };

    var resolveAssetUrl = function (value) {
        var raw = String(value || '').trim();
        if (!raw) {
            return '';
        }
        if (/^https?:\/\//i.test(raw)) {
            return raw;
        }
        if (!storageBaseUrl) {
            return raw;
        }
        var base = storageBaseUrl.replace(/\/+$/, '');
        var path = raw.replace(/^\/+/, '');
        return base + '/' + path;
    };

    var parseJsonMaybe = function (value) {
        if (!value) {
            return null;
        }
        if (typeof value === 'object') {
            return value;
        }
        if (typeof value !== 'string') {
            return null;
        }
        try {
            var parsed = JSON.parse(value);
            return parsed && typeof parsed === 'object' ? parsed : null;
        } catch (e) {
            return null;
        }
    };

    var normalizeNullablePath = function (value) {
        var path = String(value || '').trim();
        return path !== '' ? path : null;
    };

    var normalizeMethodFiles = function (value) {
        var source = value && typeof value === 'object' ? value : {};
        return {
            moderation_guide: normalizeNullablePath(source.moderation_guide),
            sketch_explanation: normalizeNullablePath(source.sketch_explanation),
            participant_template: normalizeNullablePath(source.participant_template),
            miro_template: normalizeNullablePath(source.miro_template)
        };
    };

    var normalizeMethodLinks = function (value) {
        var source = value && typeof value === 'object' ? value : {};
        return {
            tutorial_video: normalizeNullablePath(source.tutorial_video)
        };
    };

    var toStorageUrl = function (path) {
        if (!path) {
            return null;
        }
        return apiOrigin.replace(/\/+$/, '') + '/storage/' + String(path).replace(/^\/+/, '');
    };

    var ensureMethodResourcesContainer = function () {
        if (methodResourcesEl || !editorEl || !templateSectionsEl) {
            return methodResourcesEl;
        }
        methodResourcesEl = document.createElement('div');
        methodResourcesEl.id = 'kh-method-resources';
        methodResourcesEl.className = 'kh-template-section';
        methodResourcesEl.style.marginBottom = '16px';
        editorEl.insertBefore(methodResourcesEl, templateSectionsEl);
        return methodResourcesEl;
    };

    var renderMethodResources = function (item) {
        var container = ensureMethodResourcesContainer();
        if (!container) {
            return;
        }

        container.innerHTML = '';

        var files = item && item.method_files ? item.method_files : normalizeMethodFiles(null);
        var links = item && item.method_links ? item.method_links : normalizeMethodLinks(null);
        var fileDefinitions = [
            { key: 'moderation_guide', label: t('resourceModerationGuide', 'Moderation guide') },
            { key: 'sketch_explanation', label: t('resourceSketchExplanation', 'Sketch explanation') },
            { key: 'participant_template', label: t('resourceParticipantTemplate', 'Participant template') },
            { key: 'miro_template', label: t('resourceMiroTemplate', 'Miro template') }
        ];
        var availableFiles = fileDefinitions
            .map(function (definition) {
                var path = files[definition.key];
                var url = toStorageUrl(path);
                return url ? { label: definition.label, url: url } : null;
            })
            .filter(function (entry) { return !!entry; });
        var availableLinks = [];

        if (links.tutorial_video) {
            availableLinks.push({
                label: t('resourceTutorialVideo', 'Tutorial video'),
                url: links.tutorial_video
            });
        }

        var hasResources = availableFiles.length > 0 || availableLinks.length > 0;
        if (!hasResources) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('methodResourcesEmpty', 'No files/links available.');
            container.appendChild(empty);
            return;
        }

        var heading = document.createElement('h5');
        heading.textContent = t('methodResourcesHeading', 'Files & Links');
        container.appendChild(heading);

        if (availableFiles.length) {
            var filesTitle = document.createElement('p');
            filesTitle.innerHTML = '<strong>' + t('methodResourcesFilesTitle', 'Files') + '</strong>';
            container.appendChild(filesTitle);

            var fileList = document.createElement('div');
            fileList.className = 'kh-actions';
            fileList.style.display = 'flex';
            fileList.style.flexWrap = 'wrap';
            fileList.style.gap = '8px';

            availableFiles.forEach(function (fileEntry) {
                var fileLink = document.createElement('a');
                fileLink.className = 'btn btn-secondary';
                fileLink.href = fileEntry.url;
                fileLink.target = '_blank';
                fileLink.rel = 'noopener noreferrer';
                fileLink.setAttribute('download', '');
                fileLink.textContent = fileEntry.label;
                fileList.appendChild(fileLink);
            });

            container.appendChild(fileList);
        }

        if (availableLinks.length) {
            var linksTitle = document.createElement('p');
            linksTitle.style.marginTop = availableFiles.length ? '12px' : '0';
            linksTitle.innerHTML = '<strong>' + t('methodResourcesLinksTitle', 'Links') + '</strong>';
            container.appendChild(linksTitle);

            var linksList = document.createElement('div');
            linksList.className = 'kh-actions';
            linksList.style.display = 'flex';
            linksList.style.flexWrap = 'wrap';
            linksList.style.gap = '8px';

            availableLinks.forEach(function (linkEntry) {
                var linkCard = document.createElement('a');
                linkCard.className = 'btn btn-secondary';
                linkCard.href = linkEntry.url;
                linkCard.target = '_blank';
                linkCard.rel = 'noopener noreferrer';
                linkCard.textContent = linkEntry.label;
                linksList.appendChild(linkCard);
            });

            container.appendChild(linksList);
        }
    };

    var normalizeMethodItem = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var normalizeResultRecord = function (raw, idx) {
            if (!raw || typeof raw !== 'object') {
                return null;
            }
            var userObj = raw.user && typeof raw.user === 'object' ? raw.user : {};
            var userName = String(raw.user_name || raw.user_display_name || userObj.name || userObj.email || '').trim();
            var userId = parseInt(raw.user_id || userObj.id || 0, 10) || 0;
            var statusRaw = String(raw.result_status || 'empty').toLowerCase();
            var status = (statusRaw === 'draft' || statusRaw === 'completed' || statusRaw === 'empty') ? statusRaw : 'empty';
            return {
                id: parseInt(raw.id || 0, 10) || (idx + 1),
                user_id: userId,
                user_name: userName || (userId > 0 ? ('User #' + userId) : ('User #' + (idx + 1))),
                result_title: raw.result_title || null,
                result_text: raw.result_text || null,
                result_payload: parseJsonMaybe(raw.result_payload) || null,
                result_status: status,
                result_updated_at: raw.result_updated_at || raw.updated_at || null,
                created_at: raw.created_at || null
            };
        };
        var myResult = (row.my_result && typeof row.my_result === 'object') ? row.my_result : null;
        var resultSource = myResult || row;
        var nestedMethod = (
            (row.method && typeof row.method === 'object' && row.method)
            || (row.content_method && typeof row.content_method === 'object' && row.content_method)
            || (row.content && typeof row.content === 'object' && row.content)
            || (row.item && typeof row.item === 'object' && row.item)
            || {}
        );
        var itemRecordId = parseInt(
            row.record_id
            || row.id
            || row.project_method_item_id
            || 0,
            10
        ) || 0;
        var contentMethodId = parseInt(
            row.content_method_id
            || row.method_id
            || row.item_id
            || row.content_id
            || nestedMethod.id
            || 0,
            10
        ) || 0;
        var itemId = contentMethodId > 0 ? contentMethodId : itemRecordId;
        if (itemId <= 0) {
            return null;
        }
        var status = String(resultSource.result_status || 'empty').toLowerCase();
        if (status !== 'draft' && status !== 'completed' && status !== 'empty') {
            status = 'empty';
        }
        var mode = String(row.execution_mode || 'online').toLowerCase();
        if (mode !== 'offline') {
            mode = 'online';
        }

        return {
            type: 'method',
            item_id: itemId,
            record_id: itemRecordId > 0 ? itemRecordId : (parseInt(row.record_id || row.id || row.item_id || 0, 10) || null),
            content_method_id: contentMethodId > 0 ? contentMethodId : null,
            title: row.title || nestedMethod.title || null,
            description: row.description || nestedMethod.description || null,
            image: resolveAssetUrl(row.image || nestedMethod.image || ''),
            template_type: row.template_type || '',
            template_version: String(row.template_version || '1.0'),
            template_schema: parseJsonMaybe(row.template_schema),
            template_fields: Array.isArray(row.template_fields) ? row.template_fields : [],
            method_files: normalizeMethodFiles(row.method_files || nestedMethod.method_files),
            method_links: normalizeMethodLinks(row.method_links || nestedMethod.method_links),
            execution_mode: mode,
            result_title: resultSource.result_title || null,
            result_text: resultSource.result_text || null,
            result_payload: parseJsonMaybe(resultSource.result_payload) || null,
            result_status: status,
            result_updated_by: parseInt(resultSource.result_updated_by || 0, 10) || null,
            result_updated_at: resultSource.result_updated_at || null,
            created_at: row.created_at || null,
            results: (Array.isArray(row.results) ? row.results : [])
                .map(function (resultEntry, idx) { return normalizeResultRecord(resultEntry, idx); })
                .filter(function (resultEntry) { return !!resultEntry; })
        };
    };

    var apiRequest = function (method, url, body, requestOptions) {
        var optionsConfig = requestOptions && typeof requestOptions === 'object' ? requestOptions : {};
        var useOverlay = optionsConfig.useOverlay !== false;
        var headers = {
            Accept: 'application/json'
        };
        if (bearerToken !== '') {
            headers.Authorization = 'Bearer ' + bearerToken;
        }
        var options = { method: method, headers: headers };

        if (body && typeof body === 'object') {
            headers['Content-Type'] = 'application/json';
            options.body = JSON.stringify(body);
        }

        if (useOverlay) {
            showLoadingOverlay();
        }
        return fetch(url, options)
            .then(function (response) {
                return response.text().then(function (text) {
                    var parsed = null;
                    try {
                        parsed = text ? JSON.parse(text) : null;
                    } catch (e) {
                        parsed = null;
                    }

                    if (!response.ok) {
                        var error = new Error('HTTP ' + response.status);
                        error.status = response.status;
                        error.payload = parsed;
                        throw error;
                    }
                    return parsed;
                });
            })
            .finally(function () {
                if (useOverlay) {
                    hideLoadingOverlay();
                }
            });
    };

    var api = {
        listProjects: function () {
            if (!projectsEndpoint) {
                return Promise.resolve([]);
            }
            var params = new URLSearchParams();
            params.set('page', '1');
            params.set('per_page', '100');
            params.set('scope', 'all');
            return apiRequest('GET', projectsEndpoint + '?' + params.toString(), null, { useOverlay: false });
        },
        createProject: function (payload) {
            if (!projectsEndpoint) {
                return Promise.reject(new Error('Projects endpoint missing'));
            }
            return apiRequest('POST', projectsEndpoint, payload);
        },
        getProject: function (options) {
            return apiRequest('GET', baseEndpoint, null, options);
        },
        listMembers: function (options) {
            return apiRequest('GET', baseEndpoint + '/members', null, options);
        },
        listResults: function (options) {
            return apiRequest('GET', baseEndpoint + '/results', null, options);
        },
        getResult: function (resultId) {
            return apiRequest('GET', baseEndpoint + '/results/' + resultId);
        },
        createResult: function (payload) {
            return apiRequest('POST', baseEndpoint + '/results', payload);
        },
        updateResult: function (resultId, payload) {
            return apiRequest('PATCH', baseEndpoint + '/results/' + resultId, payload);
        },
        deleteResult: function (resultId) {
            return apiRequest('DELETE', baseEndpoint + '/results/' + resultId);
        },
        uploadResultFiles: function (resultId, files) {
            var headers = {
                Accept: 'application/json'
            };
            if (bearerToken !== '') {
                headers.Authorization = 'Bearer ' + bearerToken;
            }
            var body = new FormData();
            Array.prototype.slice.call(files || []).forEach(function (file) {
                body.append('files[]', file);
            });
            showLoadingOverlay();
            return fetch(baseEndpoint + '/results/' + resultId + '/files', {
                method: 'POST',
                headers: headers,
                body: body
            })
                .then(function (response) {
                    return response.text().then(function (text) {
                        var parsed = null;
                        try {
                            parsed = text ? JSON.parse(text) : null;
                        } catch (e) {
                            parsed = null;
                        }
                        if (!response.ok) {
                            var error = new Error('HTTP ' + response.status);
                            error.status = response.status;
                            error.payload = parsed;
                            throw error;
                        }
                        return parsed;
                    });
                })
                .finally(function () {
                    hideLoadingOverlay();
                });
        },
        removeResultFile: function (resultId, fileId) {
            return apiRequest('DELETE', baseEndpoint + '/results/' + resultId + '/files/' + fileId);
        },
        acceptProjectInvite: function () {
            return apiRequest('POST', baseEndpoint + '/members/accept', {});
        },
        acceptProjectInviteById: function (targetProjectId) {
            var endpoint = buildProjectEndpoint(targetProjectId);
            if (!endpoint) {
                return Promise.reject(new Error('Project endpoint missing'));
            }
            return apiRequest('POST', endpoint + '/members/accept', {});
        },
        joinPublicProjectById: function (targetProjectId) {
            var endpoint = buildProjectEndpoint(targetProjectId);
            if (!endpoint) {
                return Promise.reject(new Error('Project endpoint missing'));
            }
            return apiRequest('POST', endpoint + '/join', {});
        },
        declineProjectInviteById: function (targetProjectId) {
            var endpoint = buildProjectEndpoint(targetProjectId);
            if (!endpoint) {
                return Promise.reject(new Error('Project endpoint missing'));
            }
            return apiRequest('POST', endpoint + '/leave', {});
        },
        listProjectLinks: function () {
            return apiRequest('GET', baseEndpoint + '/links', null, { useOverlay: false });
        },
        listComments: function (options) {
            return apiRequest('GET', baseEndpoint + '/comments', null, options);
        },
        searchMethods: function (query) {
            var url = baseEndpoint + '/methods/search?q=' + encodeURIComponent(query) + '&per_page=20&include_added=0';
            return apiRequest('GET', url);
        },
        listAddedMethodsFromSearch: function () {
                var url = baseEndpoint + '/methods/search?per_page=100&include_added=1';
                return apiRequest('GET', url);
            },
            listMethods: function (options) {
                return apiRequest('GET', baseEndpoint + '/items', null, options);
            },
        addMethod: function (methodId) {
            return apiRequest('POST', baseEndpoint + '/items', { content_method_id: methodId });
        },
        getMethod: function (methodId) {
            return apiRequest('GET', baseEndpoint + '/items/' + methodId);
        },
        updateMethod: function (methodId, payload) {
            return apiRequest('PATCH', baseEndpoint + '/items/' + methodId, payload);
        },
        uploadProjectFile: function (file, contentMethodId) {
            var headers = {
                Accept: 'application/json'
            };
            if (bearerToken !== '') {
                headers.Authorization = 'Bearer ' + bearerToken;
            }
            var body = new FormData();
            body.append('file', file);
            var methodId = parseInt(contentMethodId || 0, 10) || 0;
            if (methodId > 0) {
                body.append('content_method_id', String(methodId));
            }
            showLoadingOverlay();
            return fetch(baseEndpoint + '/files', {
                method: 'POST',
                headers: headers,
                body: body
            })
                .then(function (response) {
                    return response.text().then(function (text) {
                        var parsed = null;
                        try {
                            parsed = text ? JSON.parse(text) : null;
                        } catch (e) {
                            parsed = null;
                        }
                        if (!response.ok) {
                            var error = new Error('HTTP ' + response.status);
                            error.status = response.status;
                            error.payload = parsed;
                            throw error;
                        }
                        return parsed;
                    });
                })
                .finally(function () {
                    hideLoadingOverlay();
                });
        },
        removeProjectFile: function (fileId) {
            return apiRequest('DELETE', baseEndpoint + '/files/' + fileId);
        },
        removeMethod: function (methodId) {
            return apiRequest('DELETE', baseEndpoint + '/items/' + methodId);
        }
    };

    var extractSingle = function (payload) {
        if (!payload || typeof payload !== 'object') {
            return null;
        }
        if (payload.data && !Array.isArray(payload.data) && typeof payload.data === 'object') {
            return payload.data;
        }
        return payload;
    };

    var roleLabel = function (roleRaw) {
        var role = String(roleRaw || '').trim().toLowerCase();
        if (role === 'project-owner') return t('roleOwner', 'Owner');
        if (role === 'project-admin') return t('roleAdmin', 'Admin');
        if (role === 'project-cooperator') return t('roleCooperator', 'Cooperator');
        return t('roleUnknown', 'Unknown role');
    };

    var resolveCurrentProjectRole = function (project, members) {
        var validRoles = ['project-owner', 'project-admin', 'project-cooperator'];
        var projectMembershipStatus = String(
            (project && project.membership && project.membership.status)
            || (project && project.current_member && project.current_member.status)
            || (project && project.pivot && project.pivot.status)
            || ''
        ).trim().toLowerCase();
        var candidates = [
            project && project.current_user_role,
            project && project.membership && project.membership.role,
            project && project.current_member && project.current_member.role,
            project && project.pivot && project.pivot.role
        ];

        if (projectMembershipStatus === '' || projectMembershipStatus === 'active') {
            for (var i = 0; i < candidates.length; i += 1) {
                var candidate = String(candidates[i] || '').trim();
                if (validRoles.indexOf(candidate) !== -1) {
                    return candidate;
                }
            }
        }

        if (Array.isArray(members)) {
            for (var j = 0; j < members.length; j += 1) {
                var member = members[j];
                if (!member || typeof member !== 'object') {
                    continue;
                }
                var memberRole = String(member.role || '').trim();
                if (validRoles.indexOf(memberRole) === -1) {
                    continue;
                }
                var memberStatus = String(member.status || 'active').trim().toLowerCase();
                if (memberStatus !== '' && memberStatus !== 'active') {
                    continue;
                }
                var memberEmail = String(member.email || (member.user && member.user.email) || '').trim().toLowerCase();
                var memberUserId = String(member.user_id || member.id || (member.user && member.user.id) || '').trim();

                if (currentUserEmail !== '' && memberEmail !== '' && currentUserEmail === memberEmail) {
                    return memberRole;
                }
                if (currentUserId !== '' && memberUserId !== '' && currentUserId === memberUserId) {
                    return memberRole;
                }
            }
        }

        var createdBy = project && project.created_by;
        var creatorId = createdBy && typeof createdBy === 'object'
            ? String(createdBy.id || createdBy.user_id || '').trim()
            : String((project && (createdBy || project.owner_id)) || '').trim();
        if (currentUserId !== '' && creatorId !== '' && currentUserId === creatorId) {
            return 'project-owner';
        }

        return '';
    };

    var canWriteProjectComments = function () {
        return currentProjectRole === 'project-owner' || currentProjectRole === 'project-admin' || currentProjectRole === 'project-cooperator';
    };

    var canManageProjectComments = function () {
        return currentProjectRole === 'project-owner' || currentProjectRole === 'project-admin';
    };

    var getProjectMembershipStatus = function (project) {
        return String(
            (project && project.membership && project.membership.status)
            || (project && project.current_member && project.current_member.status)
            || (project && project.pivot && project.pivot.status)
            || ''
        ).trim().toLowerCase();
    };

    var canManageMembers = function () {
        return currentProjectRole === 'project-owner' || currentProjectRole === 'project-admin';
    };

    var updateProjectRoleControls = function () {
        canManageProjectRoles = canManageMembers();

        if (openSettingsBtn) {
            openSettingsBtn.hidden = !canManageProjectRoles;
            openSettingsBtn.disabled = !canManageProjectRoles;
        }

        if (settingsModal && !canManageProjectRoles && settingsModal.getAttribute('aria-hidden') === 'false') {
            closeModal(settingsModal);
        }
    };
    updateProjectRoleControls();

    var updateCommentFormVisibility = function () {
        if (!projectCommentFormEl) {
            return;
        }
        projectCommentFormEl.style.display = canWriteProjectComments() ? '' : 'none';
    };

    var resolveProjectCoverUrl = function (project) {
        if (!project || typeof project !== 'object') {
            return '';
        }
        var candidates = [
            project.cover_image_url,
            project.cover_url,
            project.image_url,
            project.project_image_url,
            project.thumbnail_url,
            project.cover_image,
            project.cover,
            project.image,
            project.project_image,
            project.thumbnail
        ];
        for (var i = 0; i < candidates.length; i += 1) {
            var candidate = candidates[i];
            if (!candidate) {
                continue;
            }
            if (typeof candidate === 'string') {
                var url = resolveAssetUrl(candidate);
                if (url !== '') {
                    return url;
                }
                continue;
            }
            if (typeof candidate === 'object') {
                var file = normalizeProjectFile(candidate);
                if (file && file.url) {
                    return file.url;
                }
                var nested = resolveAssetUrl(candidate.url || candidate.file_url || candidate.path || candidate.src || '');
                if (nested !== '') {
                    return nested;
                }
            }
        }
        return '';
    };

    var updateProjectCover = function (project) {
        var coverUrl = resolveProjectCoverUrl(project);
        var hasCover = coverUrl !== '';
        if (projectCoverWrapEl) {
            projectCoverWrapEl.hidden = !hasCover;
        }
        if (projectCoverImageEl && hasCover) {
            projectCoverImageEl.src = coverUrl;
        }
        if (settingsCoverPreviewEl) {
            settingsCoverPreviewEl.hidden = !hasCover;
        }
        if (settingsCoverImageEl && hasCover) {
            settingsCoverImageEl.src = coverUrl;
        }
    };

    var updateSettingsFormFromProject = function (project) {
        var nameInput = document.getElementById('kh_settings_project_name');
        var descriptionInput = document.getElementById('kh_settings_project_description');
        var visibilityInput = document.getElementById('kh_settings_project_visibility');
        if (nameInput) {
            nameInput.value = String(project.name || '');
        }
        if (descriptionInput) {
            descriptionInput.value = String(project.description || '');
        }
        if (visibilityInput) {
            visibilityInput.value = String(project.visibility || 'private');
        }
    };

    var normalizeProjectItem = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var pid = parseInt(row.id || 0, 10) || 0;
        if (pid <= 0) {
            return null;
        }
        var hasMembership = !!(
            row.membership
            || row.current_member
            || row.pivot
            || row.current_user_role
            || row.member_status
        );
        return {
            id: pid,
            name: String(row.name || ''),
            description: String(row.description || ''),
            visibility: String(row.visibility || 'private'),
            updated_at: row.updated_at || row.membership_updated_at || null,
            created_at: row.created_at || row.membership_created_at || null,
            current_user_role: String(
                row.current_user_role
                || (row.membership && row.membership.role)
                || (row.current_member && row.current_member.role)
                || (row.pivot && row.pivot.role)
                || ''
            ),
            has_membership: hasMembership,
            member_status: String(
                (row.membership && row.membership.status)
                || (row.current_member && row.current_member.status)
                || (row.pivot && row.pivot.status)
                || row.member_status
                || (hasMembership ? (row.status || 'active') : '')
            ).toLowerCase()
        };
    };

    var isPublicJoinableProject = function (project) {
        if (!project) {
            return false;
        }
        var visibility = String(project.visibility || '').toLowerCase();
        var status = String(project.member_status || '').toLowerCase();
        var role = String(project.current_user_role || '').trim();
        return visibility === 'public'
            && status !== 'active'
            && status !== 'invited'
            && role === ''
            && !project.has_membership;
    };

    var joinPublicProject = function (project, button, afterJoin) {
        if (!project || !project.id) {
            return;
        }
        if (button) {
            button.disabled = true;
        }
        api.joinPublicProjectById(project.id)
            .then(function () {
                notify('success', t('projectJoinSuccess', 'Project joined.'));
                if (typeof afterJoin === 'function') {
                    return afterJoin();
                }
                return ensureProjectsLoaded(true);
            })
            .catch(function (error) {
                handleApiError(error, t('projectJoinFailed', 'Project could not be joined.'));
            })
            .finally(function () {
                if (button) {
                    button.disabled = false;
                }
            });
    };

    var createProjectJoinButton = function (project, afterJoin) {
        var joinBtn = document.createElement('button');
        joinBtn.type = 'button';
        joinBtn.className = 'btn btn-primary kh-project-join-public';
        joinBtn.setAttribute('aria-label', t('projectJoinButton', 'Join project'));

        var icon = document.createElement('span');
        icon.className = 'material-symbols-outlined';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = 'person_add';
        joinBtn.appendChild(icon);

        var label = document.createElement('span');
        label.textContent = t('projectJoinButton', 'Join project');
        joinBtn.appendChild(label);

        joinBtn.addEventListener('click', function () {
            joinPublicProject(project, joinBtn, afterJoin);
        });
        return joinBtn;
    };

    var extractSingleProject = function (payload) {
        var source = extractSingle(payload);
        if (source && source.data && typeof source.data === 'object' && !Array.isArray(source.data)) {
            source = source.data;
        }
        return normalizeProjectItem(source);
    };

    var buildProjectOpenUrl = function (pid) {
        var target = new URL(projectPageUrl || window.location.href, window.location.origin);
        target.searchParams.set('project_id', String(pid));
        return target.toString();
    };

    var buildProjectEndpoint = function (pid) {
        var numericId = parseInt(pid || 0, 10) || 0;
        if (numericId <= 0) {
            return '';
        }

        if (projectBaseEndpoint) {
            return projectBaseEndpoint.replace(/\/+$/, '') + '/' + numericId;
        }

        if (baseEndpoint) {
            if (projectId > 0) {
                return baseEndpoint;
            }
            return baseEndpoint.replace(/\/\d+\/?$/, '') + '/' + numericId;
        }

        return '';
    };

    var normalizeProjectFile = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var fileId = parseInt(row.id || row.file_id || row.media_id || 0, 10) || 0;
        var fileUrl = String(row.url || row.file_url || row.download_url || row.path || row.href || '').trim();
        var fileName = String(
            row.original_name
            || row.original_filename
            || row.original_file_name
            || row.client_original_name
            || row.client_filename
            || row.uploaded_name
            || row.display_name
            || row.title
            || row.name
            || row.filename
            || row.file_name
            || ''
        ).trim();
        if (fileId <= 0 && fileUrl === '' && fileName === '') {
            return null;
        }
        if (fileName === '' && fileUrl !== '') {
            try {
                fileName = decodeURIComponent(fileUrl.split('/').pop() || '');
            } catch (e) {
                fileName = fileUrl.split('/').pop() || '';
            }
        }
        return {
            id: fileId,
            name: fileName || ('File #' + (fileId || '0')),
            url: fileUrl,
            mime: String(row.mime_type || row.mime || row.type || '').trim(),
            size: parseInt(row.size || row.file_size || 0, 10) || 0,
            project_result_id: parseInt(
                row.project_result_id
                || (row.project_result && typeof row.project_result === 'object' ? row.project_result.id : row.project_result)
                || 0,
                10
            ) || 0,
            project_method_id: parseInt(
                row.project_method_id
                || (row.project_method && typeof row.project_method === 'object' ? row.project_method.id : row.project_method)
                || row.project_method_item_id
                || row.item_id
                || row.content_method_id
                || 0,
                10
            ) || 0
        };
    };

    var normalizeUserSummary = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var id = parseInt(row.id || row.user_id || 0, 10) || 0;
        var name = String(row.name || row.display_name || row.email || '').trim();
        var email = String(row.email || '').trim();
        if (id <= 0 && name === '' && email === '') {
            return null;
        }
        return {
            id: id,
            name: name || email || ('User #' + (id || '0')),
            email: email
        };
    };

    var normalizeResultMethodLink = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var recordId = parseInt(row.record_id || row.id || 0, 10) || 0;
        var methodId = parseInt(row.method_id || row.content_method_id || row.item_id || 0, 10) || 0;
        return {
            record_id: recordId,
            method_id: methodId,
            title: String(row.title || row.name || '').trim(),
            short_description: String(row.short_description || row.description || '').trim(),
            image: resolveAssetUrl(row.image || '')
        };
    };

    var extractResultFiles = function (source) {
        if (!source || typeof source !== 'object') {
            return [];
        }
        var candidates = [
            source.files,
            source.result_files,
            source.attachments,
            source.data && source.data.files,
            source.data && source.data.result_files,
            source.file,
            source.data && source.data.file
        ];
        for (var i = 0; i < candidates.length; i += 1) {
            var candidate = candidates[i];
            if (Array.isArray(candidate)) {
                return candidate.map(normalizeProjectFile).filter(function (item) { return !!item; });
            }
            if (candidate && typeof candidate === 'object') {
                var single = normalizeProjectFile(candidate);
                if (single) {
                    return [single];
                }
            }
        }
        return [];
    };

    var normalizeProjectResult = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var rid = parseInt(row.id || row.result_id || 0, 10) || 0;
        if (rid <= 0) {
            return null;
        }
        var image = row.image && typeof row.image === 'object' ? normalizeProjectFile(row.image) : null;
        var assignedUser = normalizeUserSummary(
            (row.assigned_user && typeof row.assigned_user === 'object' ? row.assigned_user : null)
            || (row.assigned_to && typeof row.assigned_to === 'object' ? row.assigned_to : null)
            || (row.assignee && typeof row.assignee === 'object' ? row.assignee : null)
        );
        var updatedBy = normalizeUserSummary(
            (row.updated_by && typeof row.updated_by === 'object' ? row.updated_by : null)
            || (row.updated_by_user && typeof row.updated_by_user === 'object' ? row.updated_by_user : null)
        );
        var createdBy = normalizeUserSummary(
            (row.created_by && typeof row.created_by === 'object' ? row.created_by : null)
            || (row.created_by_user && typeof row.created_by_user === 'object' ? row.created_by_user : null)
        );
        var methods = Array.isArray(row.methods)
            ? row.methods.map(normalizeResultMethodLink).filter(function (item) { return !!item; })
            : [];
        var schema = parseJsonMaybe(row.template_schema) || (row.template_schema && typeof row.template_schema === 'object' ? row.template_schema : null);
        var payload = parseJsonMaybe(row.payload) || (row.payload && typeof row.payload === 'object' ? row.payload : {});
        var status = String(row.status || 'draft').toLowerCase();
        if (status !== 'draft' && status !== 'in_progress' && status !== 'completed') {
            status = 'draft';
        }
        var files = extractResultFiles(row);
        return {
            id: rid,
            title: String(row.title || '').trim(),
            short_description: String(row.short_description || '').trim(),
            description: String(row.description || '').trim(),
            image: image,
            image_file_id: parseInt(row.image_file_id || (image && image.id) || 0, 10) || null,
            status: status,
            assigned_user_id: parseInt(row.assigned_user_id || (assignedUser && assignedUser.id) || 0, 10) || null,
            assigned_user: assignedUser,
            methods: methods,
            project_method_ids: methods.map(function (method) { return method.record_id || method.method_id; }).filter(function (id) { return !!id; }),
            template_type: String(row.template_type || '').trim().toLowerCase(),
            template_version: String(row.template_version || '1.0').trim(),
            template_schema: schema,
            payload: payload && typeof payload === 'object' ? payload : {},
            files: files,
            files_count: parseInt(row.files_count || files.length || 0, 10) || 0,
            updated_by: updatedBy,
            updated_at: row.updated_at || null,
            created_by: createdBy,
            created_at: row.created_at || null
        };
    };

    var resolveResultPreviewImage = function (resultItem) {
        if (!resultItem || typeof resultItem !== 'object') {
            return null;
        }

        if (resultItem.image && resultItem.image.url) {
            return resultItem.image;
        }

        var selectedImageId = parseInt(resultItem.image_file_id || 0, 10) || 0;
        var files = Array.isArray(resultItem.files) ? resultItem.files : [];

        if (selectedImageId > 0) {
            for (var i = 0; i < files.length; i += 1) {
                var selectedFile = files[i];
                if (!selectedFile || parseInt(selectedFile.id || 0, 10) !== selectedImageId) {
                    continue;
                }
                if (resolveFileTypeGroup(selectedFile) === 'image' && selectedFile.url) {
                    return selectedFile;
                }
            }
        }

        for (var j = 0; j < files.length; j += 1) {
            var fileItem = files[j];
            if (fileItem && resolveFileTypeGroup(fileItem) === 'image' && fileItem.url) {
                return fileItem;
            }
        }

        return null;
    };

    var formatResultDate = function (value) {
        var raw = String(value || '').trim();
        if (!raw) {
            return '';
        }
        var timestamp = Date.parse(raw);
        if (Number.isNaN(timestamp)) {
            return raw;
        }
        try {
            return new Intl.DateTimeFormat(document.documentElement.lang || 'de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }).format(new Date(timestamp));
        } catch (e) {
            return raw;
        }
    };

    var normalizeProjectLink = function (row) {
        if (!row || typeof row !== 'object') {
            return null;
        }
        var linkUrl = String(row.url || row.href || '').trim();
        if (linkUrl === '') {
            return null;
        }
        return {
            id: parseInt(row.id || row.link_id || 0, 10) || 0,
            title: String(row.title || row.name || linkUrl).trim(),
            url: linkUrl
        };
    };

    var extractProjectFiles = function (source) {
        if (!source || typeof source !== 'object') {
            return [];
        }
        var candidates = [
            source.files,
            source.project_files,
            source.attachments,
            source.documents,
            source.data && source.data.files,
            source.data && source.data.project_files,
            source.file,
            source.data && source.data.file
        ];
        for (var i = 0; i < candidates.length; i += 1) {
            var candidate = candidates[i];
            if (Array.isArray(candidate)) {
                return candidate.map(normalizeProjectFile).filter(function (item) { return !!item; });
            }
            if (candidate && typeof candidate === 'object') {
                var single = normalizeProjectFile(candidate);
                if (single) {
                    return [single];
                }
            }
        }
        return [];
    };

    var mergeProjectFiles = function (rows) {
        var map = {};
        (Array.isArray(rows) ? rows : []).map(normalizeProjectFile).filter(function (item) { return !!item; }).forEach(function (item) {
            var key = String(item.id || '') + '|' + item.url + '|' + item.name;
            map[key] = item;
        });
        return Object.keys(map).map(function (key) {
            return map[key];
        });
    };

    var mergeProjectLinks = function (rows) {
        var map = {};
        (Array.isArray(rows) ? rows : []).map(normalizeProjectLink).filter(function (item) { return !!item; }).forEach(function (item) {
            var key = String(item.id || '') + '|' + item.url;
            map[key] = item;
        });
        return Object.keys(map).map(function (key) {
            return map[key];
        });
    };

    var formatFileSize = function (bytes) {
        var value = parseInt(bytes || 0, 10) || 0;
        if (value <= 0) {
            return '';
        }
        if (value < 1024 * 1024) {
            return Math.round(value / 1024) + ' KB';
        }
        return (value / (1024 * 1024)).toFixed(1) + ' MB';
    };

    var detectFileExtension = function (fileItem) {
        var name = String(fileItem && fileItem.name || '').toLowerCase();
        if (name.indexOf('.') !== -1) {
            return name.split('.').pop() || '';
        }

        var mime = String(fileItem && fileItem.mime || '').toLowerCase();
        if (mime.indexOf('wordprocessingml') !== -1) return 'docx';
        if (mime.indexOf('spreadsheetml') !== -1) return 'xlsx';
        if (mime.indexOf('csv') !== -1) return 'csv';
        if (mime.indexOf('pdf') !== -1) return 'pdf';
        if (mime.indexOf('plain') !== -1) return 'txt';
        if (mime.indexOf('jpeg') !== -1) return 'jpg';
        if (mime.indexOf('png') !== -1) return 'png';
        return '';
    };

    var resolveFileIconName = function (extension) {
        var ext = String(extension || '').toLowerCase();
        if (ext === 'pdf') return 'picture_as_pdf';
        if (ext === 'doc' || ext === 'docx') return 'description';
        if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') return 'table_chart';
        if (ext === 'txt') return 'notes';
        if (ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif' || ext === 'webp' || ext === 'svg') return 'image';
        return 'insert_drive_file';
    };

    var resolveFileTypeGroup = function (fileItem) {
        var ext = detectFileExtension(fileItem);
        var mime = String(fileItem && fileItem.mime || '').toLowerCase();
        if (
            ext === 'jpg' || ext === 'jpeg' || ext === 'png' || ext === 'gif' || ext === 'webp' || ext === 'svg'
            || mime.indexOf('image/') === 0
        ) return 'image';
        if (ext === 'pdf' || mime.indexOf('pdf') !== -1) return 'pdf';
        if (
            ext === 'doc' || ext === 'docx' || ext === 'xls' || ext === 'xlsx' || ext === 'csv' || ext === 'ppt' || ext === 'pptx'
            || mime.indexOf('officedocument') !== -1 || mime.indexOf('msword') !== -1 || mime.indexOf('excel') !== -1
            || mime.indexOf('powerpoint') !== -1 || mime.indexOf('spreadsheetml') !== -1 || mime.indexOf('wordprocessingml') !== -1
        ) return 'office';
        if (ext === 'txt' || ext === 'md' || ext === 'rtf' || mime.indexOf('text/') === 0) return 'text';
        return 'other';
    };

    var getActiveProjectFileTypeFilter = function () {
        var value = String(projectFilesTypeFilterEl && projectFilesTypeFilterEl.value ? projectFilesTypeFilterEl.value : 'all').toLowerCase();
        if (value === 'image' || value === 'pdf' || value === 'office' || value === 'text' || value === 'other') {
            return value;
        }
        return 'all';
    };

    var fileMatchesTypeFilter = function (fileItem) {
        var active = getActiveProjectFileTypeFilter();
        if (active === 'all') return true;
        return resolveFileTypeGroup(fileItem) === active;
    };

    var shouldSuggestDownloadName = function (fileItem) {
        var group = resolveFileTypeGroup(fileItem);
        return group !== 'pdf' && group !== 'image';
    };

    var getProjectFileOpenUrl = function (fileItem) {
        var fileId = parseInt(fileItem && fileItem.id || 0, 10) || 0;
        var resultId = parseInt(fileItem && fileItem.project_result_id || 0, 10) || 0;
        if (fileId > 0 && resultId <= 0 && baseEndpoint) {
            return baseEndpoint.replace(/\/+$/, '') + '/files/' + fileId + '/download';
        }
        return String(fileItem && fileItem.url || '');
    };

    var renderProjectFiles = function () {
        if (!projectFilesListEl) {
            return;
        }
        projectFilesListEl.innerHTML = '';

        var renderSettingsProjectFiles = function () {
            if (!settingsProjectFilesListEl) {
                return;
            }
            settingsProjectFilesListEl.innerHTML = '';
            var visibleSettingsFiles = projectFilesCache.filter(fileMatchesTypeFilter);
            if (!visibleSettingsFiles.length) {
                var emptySettings = document.createElement('p');
                emptySettings.className = 'kh-meta';
                emptySettings.textContent = projectFilesCache.length
                    ? t('projectFileTypeNoMatches', 'No files for the selected file type.')
                    : t('noProjectFilesYet', 'No files or links in this project yet.');
                settingsProjectFilesListEl.appendChild(emptySettings);
                return;
            }
            var list = document.createElement('div');
            list.className = 'ih-content-stack';
            visibleSettingsFiles.forEach(function (fileItem) {
                var row = document.createElement('div');
                row.className = 'file-item';

                var icon = document.createElement('div');
                icon.className = 'file-icon';
                icon.innerHTML = '<span class="material-symbols-outlined" aria-hidden="true">' + resolveFileIconName(detectFileExtension(fileItem)) + '</span>';
                row.appendChild(icon);

                var info = document.createElement('div');
                info.className = 'file-info';
                var nameEl = document.createElement('div');
                nameEl.className = 'file-name';
                nameEl.textContent = fileItem.name;
                info.appendChild(nameEl);
                row.appendChild(info);

                var fileOpenUrl = getProjectFileOpenUrl(fileItem);
                if (fileOpenUrl) {
                    var openBtn = document.createElement('a');
                    openBtn.className = 'link-btn';
                    openBtn.href = fileOpenUrl;
                    openBtn.target = '_blank';
                    openBtn.rel = 'noopener noreferrer';
                    if (shouldSuggestDownloadName(fileItem)) {
                        openBtn.download = fileItem.name;
                    }
                    openBtn.textContent = t('openFile', 'Open file');
                    row.appendChild(openBtn);
                }

                if (canDeleteProjectFiles && fileItem.id > 0) {
                    var deleteButton = document.createElement('button');
                    deleteButton.className = 'btn btn-delete';
                    deleteButton.type = 'button';
                    deleteButton.textContent = t('deleteFileLabel', 'Delete file');
                    deleteButton.addEventListener('click', function () {
                        if (!window.confirm(t('confirmDeleteFile', 'Really delete this file?'))) {
                            return;
                        }
                        deleteButton.disabled = true;
                        api.removeProjectFile(fileItem.id)
                            .then(function (payload) {
                                projectFilesCache = projectFilesCache.filter(function (entry) {
                                    return parseInt(entry.id || 0, 10) !== fileItem.id;
                                });
                                renderProjectFiles();
                                renderMethodList(methodsCache);
                                notify('success', buildFlashMessage(payload, t('projectFileDeleted', 'File deleted.')));
                            })
                            .catch(function (error) {
                                var status = error && error.status ? error.status : 0;
                                if (status === 401) {
                                    notify('warning', t('sessionExpired', 'Session expired. Please sign in again.'));
                                    window.setTimeout(function () { window.location.reload(); }, 600);
                                    return;
                                }
                                if (status === 403) {
                                    notify('warning', t('projectFileDeleteForbidden', 'You are not allowed to delete this file.'));
                                    return;
                                }
                                handleApiError(error, t('projectFileDeleteFailed', 'File could not be deleted.'));
                            })
                            .finally(function () {
                                deleteButton.disabled = false;
                            });
                    });
                    row.appendChild(deleteButton);
                }
                list.appendChild(row);
            });
            settingsProjectFilesListEl.appendChild(list);
        };

        if (!projectFilesCache.length && !projectLinksCache.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noProjectFilesYet', 'No files or links in this project yet.');
            projectFilesListEl.appendChild(empty);
            renderSettingsProjectFiles();
            return;
        }

        var createFileRow = function (fileItem) {
            var row = document.createElement('div');
            row.className = 'file-item';

            var icon = document.createElement('div');
            icon.className = 'file-icon';
            var extension = detectFileExtension(fileItem);
            var iconName = resolveFileIconName(extension);
            icon.innerHTML = '<span class="material-symbols-outlined" aria-hidden="true">' + iconName + '</span>';
            row.appendChild(icon);

            var info = document.createElement('div');
            info.className = 'file-info';

            var nameEl = document.createElement('div');
            nameEl.className = 'file-name';
            nameEl.textContent = fileItem.name;
            info.appendChild(nameEl);

            var metaParts = [];
            if (fileItem.size > 0) {
                metaParts.push(formatFileSize(fileItem.size));
            }
            if (fileItem.mime) {
                metaParts.push(fileItem.mime);
            }
            if (metaParts.length) {
                var meta = document.createElement('div');
                meta.className = 'file-meta';
                meta.textContent = metaParts.join(' · ');
                info.appendChild(meta);
            }

            row.appendChild(info);

            var fileOpenUrl = getProjectFileOpenUrl(fileItem);
            if (fileOpenUrl) {
                var openBtn = document.createElement('a');
                openBtn.className = 'link-btn';
                openBtn.href = fileOpenUrl;
                openBtn.target = '_blank';
                openBtn.rel = 'noopener noreferrer';
                if (shouldSuggestDownloadName(fileItem)) {
                    openBtn.download = fileItem.name;
                }
                openBtn.textContent = t('openFile', 'Open file');
                row.appendChild(openBtn);
            }

            if (canDeleteProjectFiles && fileItem.id > 0) {
                var deleteButton = document.createElement('button');
                deleteButton.className = 'btn btn-delete';
                deleteButton.type = 'button';
                deleteButton.textContent = t('deleteFileLabel', 'Delete file');
                deleteButton.addEventListener('click', function () {
                    if (!window.confirm(t('confirmDeleteFile', 'Really delete this file?'))) {
                        return;
                    }
                    deleteButton.disabled = true;
                    api.removeProjectFile(fileItem.id)
                        .then(function (payload) {
                            projectFilesCache = projectFilesCache.filter(function (entry) {
                                return parseInt(entry.id || 0, 10) !== fileItem.id;
                            });
                            renderProjectFiles();
                            renderMethodList(methodsCache);
                            notify('success', buildFlashMessage(payload, t('projectFileDeleted', 'File deleted.')));
                        })
                        .catch(function (error) {
                            var status = error && error.status ? error.status : 0;
                            if (status === 401) {
                                notify('warning', t('sessionExpired', 'Session expired. Please sign in again.'));
                                window.setTimeout(function () { window.location.reload(); }, 600);
                                return;
                            }
                            if (status === 403) {
                                notify('warning', t('projectFileDeleteForbidden', 'You are not allowed to delete this file.'));
                                return;
                            }
                            handleApiError(error, t('projectFileDeleteFailed', 'File could not be deleted.'));
                        })
                        .finally(function () {
                            deleteButton.disabled = false;
                        });
                });
                row.appendChild(deleteButton);
            }

            return row;
        };

        var projectFiles = [];
        var methodFilesByMethodId = {};
        var visibleFilesCount = 0;
        projectFilesCache.forEach(function (fileItem) {
            if ((parseInt(fileItem && fileItem.project_result_id || 0, 10) || 0) > 0) {
                return;
            }
            if (!fileMatchesTypeFilter(fileItem)) {
                return;
            }
            var methodRef = parseInt(fileItem && fileItem.project_method_id || 0, 10) || 0;
            if (methodRef > 0) {
                if (!Array.isArray(methodFilesByMethodId[methodRef])) {
                    methodFilesByMethodId[methodRef] = [];
                }
                methodFilesByMethodId[methodRef].push(fileItem);
                visibleFilesCount += 1;
                return;
            }
            projectFiles.push(fileItem);
            visibleFilesCount += 1;
        });

        if (projectFiles.length) {
            var projectFilesTitle = document.createElement('p');
            projectFilesTitle.className = 'ih-files-section-title';
            projectFilesTitle.innerHTML = '<strong>' + t('projectFilesGeneralTitle', 'General project files') + '</strong>';
            projectFilesListEl.appendChild(projectFilesTitle);

            var projectFileList = document.createElement('div');
            projectFileList.className = 'ih-content-stack ih-files-section-body';
            projectFiles.forEach(function (fileItem) {
                projectFileList.appendChild(createFileRow(fileItem));
            });
            projectFilesListEl.appendChild(projectFileList);
        }

        var methodIds = Object.keys(methodFilesByMethodId);
        if (methodIds.length) {
            var methodFilesTitle = document.createElement('p');
            methodFilesTitle.className = 'ih-files-section-title';
            methodFilesTitle.innerHTML = '<strong>' + t('projectFilesByMethodTitle', 'Method result files') + '</strong>';
            projectFilesListEl.appendChild(methodFilesTitle);

            methodIds
                .map(function (value) { return parseInt(value, 10) || 0; })
                .filter(function (value) { return value > 0; })
                .sort(function (a, b) { return a - b; })
                .forEach(function (methodId) {
                    var methodWrap = document.createElement('div');
                    methodWrap.className = 'ih-method-file-group';

                    var methodLabel = document.createElement('p');
                    methodLabel.className = 'kh-meta ih-method-file-group-label';
                    var method = methodsCache.find(function (entry) { return entry.item_id === methodId; }) || null;
                    methodLabel.innerHTML = '<strong>' + (method && method.title ? method.title : (t('methodLabel', 'Method') + ' #' + methodId)) + '</strong>';
                    methodWrap.appendChild(methodLabel);

                    var methodFileList = document.createElement('div');
                    methodFileList.className = 'ih-content-stack';
                    methodFilesByMethodId[methodId].forEach(function (fileItem) {
                        methodFileList.appendChild(createFileRow(fileItem));
                    });
                    methodWrap.appendChild(methodFileList);
                    projectFilesListEl.appendChild(methodWrap);
                });
        }

        if (visibleFilesCount === 0) {
            var noTypeMatches = document.createElement('p');
            noTypeMatches.className = 'kh-meta';
            noTypeMatches.textContent = t('projectFileTypeNoMatches', 'No files for the selected file type.');
            projectFilesListEl.appendChild(noTypeMatches);
        }

        if (projectLinksCache.length) {
            var linksTitle = document.createElement('p');
            linksTitle.style.marginTop = '12px';
            linksTitle.innerHTML = '<strong>' + t('projectLinksTitle', 'Links') + '</strong>';
            projectFilesListEl.appendChild(linksTitle);

            var linkList = document.createElement('div');
            linkList.className = 'kh-content-stack';
            projectLinksCache.forEach(function (linkItem) {
                var row = document.createElement('div');
                row.className = 'kh-content-item';

                var title = document.createElement('strong');
                title.textContent = linkItem.title;
                row.appendChild(title);

                var urlMeta = document.createElement('p');
                urlMeta.className = 'kh-meta';
                urlMeta.textContent = linkItem.url;
                row.appendChild(urlMeta);

                var actions = document.createElement('div');
                actions.className = 'kh-actions';
                var link = document.createElement('a');
                link.className = 'btn btn-secondary';
                link.href = linkItem.url;
                link.target = '_blank';
                link.rel = 'noopener noreferrer';
                link.textContent = t('openLinkLabel', 'Open link');
                actions.appendChild(link);
                row.appendChild(actions);

                linkList.appendChild(row);
            });
            projectFilesListEl.appendChild(linkList);
        }
        renderSettingsProjectFiles();
    };

    var validateProjectFile = function (file) {
        if (!file) {
            return t('projectFileRequired', 'Please select a file.');
        }
        var extension = String(file.name || '').split('.').pop().toLowerCase();
        if (uploadAllowedExtensions.indexOf(extension) === -1) {
            return t('projectFileInvalidType', 'File type not allowed. Allowed types are PDF, TXT, DOCX, CSV, XLSX, JPG, JPEG and PNG.');
        }
        if (file.size > uploadMaxBytes) {
            return t('projectFileTooLarge', 'File is larger than 20 MB.');
        }
        return '';
    };

    var renderProjectFileMethodOptions = function () {
        if (!projectFileMethodSelectEl) {
            return;
        }
        var selectedValue = parseInt(projectFileMethodSelectEl.value || 0, 10) || 0;
        projectFileMethodSelectEl.innerHTML = '';

        var emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = t('projectFileNoMethod', 'Without method reference');
        projectFileMethodSelectEl.appendChild(emptyOption);

        methodsCache.forEach(function (methodItem) {
            var methodId = parseInt(methodItem.item_id || 0, 10) || 0;
            if (methodId <= 0) {
                return;
            }
            var option = document.createElement('option');
            option.value = String(methodId);
            option.textContent = String(methodItem.title || (t('methodLabel', 'Method') + ' #' + methodId));
            if (selectedValue > 0 && methodId === selectedValue) {
                option.selected = true;
            }
            projectFileMethodSelectEl.appendChild(option);
        });
    };

    var renderProjectList = function (rows) {
        if (!projectListEl) {
            return;
        }
        projectListEl.innerHTML = '';
        var normalized = (Array.isArray(rows) ? rows : []).map(normalizeProjectItem).filter(function (item) { return !!item; });
        if (!normalized.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noProjectsFound', 'No projects found.');
            projectListEl.appendChild(empty);
            return;
        }
        normalized.forEach(function (project) {
            var isInvite = String(project.member_status || 'active').toLowerCase() === 'invited';
            var article = createHomeProjectCard(project, isInvite ? 'invite' : 'active');
            if (!article) {
                return;
            }
            article.classList.add('kh-project-card');
            projectListEl.appendChild(article);
        });
    };

    var getProjectSortTimestamp = function (project) {
        if (!project || typeof project !== 'object') {
            return 0;
        }
        var candidates = [project.updated_at, project.created_at];
        for (var i = 0; i < candidates.length; i += 1) {
            var value = String(candidates[i] || '').trim();
            if (!value) {
                continue;
            }
            var timestamp = Date.parse(value);
            if (!Number.isNaN(timestamp)) {
                return timestamp;
            }
        }
        return 0;
    };

    var createHomeProjectCard = function (project, cardType) {
        var normalizedProject = normalizeProjectItem(project);
        if (!normalizedProject) {
            return null;
        }

        var article = document.createElement('article');
        article.className = 't-button-directory kh-home-project-card grid-item';
        if (cardType === 'invite') {
            article.classList.add('kh-home-project-card-invite');
        }
        article.setAttribute('data-project-id', String(normalizedProject.id));

        var inner = document.createElement('div');
        inner.className = 't-btn-dir-column kh-home-project-card-inner';

        var top = document.createElement('div');
        top.className = 'kh-home-project-card-top';

        var icon = document.createElement('span');
        icon.className = 'material-symbols-outlined kh-home-project-card-icon';
        icon.setAttribute('aria-hidden', 'true');
        icon.textContent = cardType === 'invite' ? 'mail' : 'person_play';
        top.appendChild(icon);

        if (cardType === 'invite') {
            var statusBadge = document.createElement('span');
            statusBadge.className = 't-tag ih-badge ih-badge-p-role kh-home-project-badge kh-home-project-badge-status';
            statusBadge.textContent = t('memberStatusInvited', 'Invited');
            top.appendChild(statusBadge);
        }

        var visibilityBadge = document.createElement('span');
        visibilityBadge.className = 't-tag ih-badge ih-badge-p-visibility kh-home-project-badge';
        visibilityBadge.textContent = normalizedProject.visibility;
        top.appendChild(visibilityBadge);
        inner.appendChild(top);

        var body = document.createElement('div');
        body.className = 't-btn-dir-inner';

        var info = document.createElement('div');
        info.className = 't-btn-dir-info';

        var titleWrap = document.createElement('div');
        titleWrap.className = 't-btn-dir-info-title';
        var title = document.createElement('h3');
        title.textContent = normalizedProject.name !== '' ? normalizedProject.name : t('untitledProject', 'Untitled project');
        titleWrap.appendChild(title);
        info.appendChild(titleWrap);

        var description = document.createElement('div');
        description.className = 't-btn-dir-info-subtitle text-trim-row-3';
        description.textContent = normalizedProject.description !== ''
            ? normalizedProject.description
            : (cardType === 'invite'
                ? t('inviteBannerText', 'You have been invited to this project. Please accept the invitation to actively participate.')
                : t('noDescriptionAvailable', 'No description available.'));
        info.appendChild(description);

        if (cardType !== 'invite') {
            var updatedAt = getProjectSortTimestamp(normalizedProject);
            if (updatedAt > 0) {
                var meta = document.createElement('p');
                meta.className = 'kh-home-project-meta';
                meta.textContent = t('homeProjectsUpdatedLabel', 'Last updated') + ': '
                    + new Date(updatedAt).toLocaleDateString();
                info.appendChild(meta);
            }
        }

        body.appendChild(info);

        var actions = document.createElement('div');
        actions.className = 'kh-actions kh-home-project-card-actions';

        if (cardType === 'invite') {
            var acceptBtn = document.createElement('button');
            acceptBtn.type = 'button';
            acceptBtn.className = 'btn btn-primary kh-home-project-accept';
            acceptBtn.textContent = t('inviteAcceptButton', 'Accept invitation');
            acceptBtn.addEventListener('click', function () {
                acceptBtn.disabled = true;
                api.acceptProjectInviteById(normalizedProject.id)
                    .then(function () {
                        notify('success', t('inviteAcceptSuccess', 'Invitation accepted.'));
                        return ensureProjectsLoaded(true).then(function (rows) {
                            renderProjectsEverywhere(rows);
                        });
                    })
                    .catch(function (error) {
                        handleApiError(error, t('inviteAcceptFailed', 'Invitation could not be accepted.'));
                    })
                    .finally(function () {
                        acceptBtn.disabled = false;
                    });
            });
            actions.appendChild(acceptBtn);

            var declineBtn = document.createElement('button');
            declineBtn.type = 'button';
            declineBtn.className = 'btn btn-secondary kh-home-project-decline';
            declineBtn.textContent = t('inviteDeclineButton', 'Decline invitation');
            declineBtn.addEventListener('click', function () {
                declineBtn.disabled = true;
                api.declineProjectInviteById(normalizedProject.id)
                    .then(function () {
                        notify('success', t('inviteDeclineSuccess', 'Invitation declined.'));
                        return ensureProjectsLoaded(true).then(function (rows) {
                            renderProjectsEverywhere(rows);
                        });
                    })
                    .catch(function (error) {
                        handleApiError(error, t('inviteDeclineFailed', 'Invitation could not be declined.'));
                    })
                    .finally(function () {
                        declineBtn.disabled = false;
                    });
            });
            actions.appendChild(declineBtn);
        } else if (isPublicJoinableProject(normalizedProject)) {
            actions.appendChild(createProjectJoinButton(normalizedProject, function () {
                return ensureProjectsLoaded(true).then(function (rows) {
                    renderProjectsEverywhere(rows);
                });
            }));
        }

        if (!isPublicJoinableProject(normalizedProject)) {
            var openLink = document.createElement('a');
            openLink.className = 'btn btn-secondary';
            openLink.href = buildProjectOpenUrl(normalizedProject.id);
            openLink.textContent = t('openProjectDashboard', 'Open project dashboard');
            actions.appendChild(openLink);
        }

        body.appendChild(actions);
        inner.appendChild(body);
        article.appendChild(inner);
        return article;
    };

    var renderHomeProjectsOverview = function (rows) {
        if (!homeProjectListEl) {
            return;
        }

        var normalized = (Array.isArray(rows) ? rows : []).map(normalizeProjectItem).filter(function (item) { return !!item; });
        var invited = normalized
            .filter(function (project) { return String(project.member_status || 'active').toLowerCase() === 'invited'; })
            .sort(function (left, right) { return getProjectSortTimestamp(right) - getProjectSortTimestamp(left); });
        var active = normalized
            .filter(function (project) {
                return String(project.member_status || 'active').toLowerCase() !== 'invited'
                    && !isPublicJoinableProject(project);
            })
            .sort(function (left, right) { return getProjectSortTimestamp(right) - getProjectSortTimestamp(left); })
            .slice(0, homeLatestProjectsLimit);

        homeProjectListEl.innerHTML = '';
        if (!active.length) {
            var emptyState = document.createElement('div');
            emptyState.className = 'kh-home-project-empty-state';

            var empty = document.createElement('p');
            empty.className = 'kh-home-project-empty';
            empty.textContent = t('homeProjectsEmpty', 'You do not have any active projects yet. Go to the InnoHub to create your first project.');
            emptyState.appendChild(empty);

            var emptyLink = document.createElement('a');
            emptyLink.className = 'btn t-btn t-btn-primary kh-home-project-empty-link';
            emptyLink.href = projectPageUrl || listUrl || window.location.href;
            emptyLink.textContent = t('homeProjectsEmptyCta', 'Go to project dashboard');
            emptyState.appendChild(emptyLink);
            homeProjectListEl.appendChild(emptyState);
        } else {
            active.forEach(function (project) {
                var card = createHomeProjectCard(project, 'project');
                if (card) {
                    homeProjectListEl.appendChild(card);
                }
            });
        }

        if (!homeProjectInvitesSectionEl || !homeProjectInvitesListEl) {
            return;
        }

        homeProjectInvitesListEl.innerHTML = '';
        if (!invited.length) {
            homeProjectInvitesSectionEl.style.display = 'none';
            return;
        }

        invited.forEach(function (project) {
            var card = createHomeProjectCard(project, 'invite');
            if (card) {
                homeProjectInvitesListEl.appendChild(card);
            }
        });
        homeProjectInvitesSectionEl.style.display = '';
    };

    var renderProjectsEverywhere = function (rows) {
        var normalizedRows = (Array.isArray(rows) ? rows : []).map(normalizeProjectItem).filter(function (item) { return !!item; });
        if (projectListEl) {
            renderProjectList(filterProjectsLocally(projectSearchInput ? projectSearchInput.value : '', normalizedRows));
        }
        if (homeProjectListEl) {
            renderHomeProjectsOverview(normalizedRows);
        }
    };

    var filterProjectsLocally = function (query, rows) {
        var normalizedRows = (Array.isArray(rows) ? rows : []).map(normalizeProjectItem).filter(function (item) { return !!item; });
        var searchValue = String(query || '').trim().toLowerCase();
        if (searchValue === '') {
            return normalizedRows;
        }
        return normalizedRows.filter(function (project) {
            var haystack = [
                String(project.name || '').toLowerCase(),
                String(project.description || '').toLowerCase(),
                String(project.visibility || '').toLowerCase()
            ].join(' ');
            return haystack.indexOf(searchValue) !== -1;
        });
    };

    var ensureProjectsLoaded = function (forceRefresh) {
        if (!forceRefresh && projectsLoadedOnce && projectsCache.length) {
            return Promise.resolve(projectsCache);
        }
        if (!forceRefresh && projectsFetchPromise) {
            return projectsFetchPromise;
        }
        projectsFetchPromise = api.listProjects()
            .then(function (payload) {
                var rows = extractRows(payload);
                projectsCache = (Array.isArray(rows) ? rows : []).map(normalizeProjectItem).filter(function (item) { return !!item; });
                projectsLoadedOnce = true;
                renderProjectsEverywhere(projectsCache);
                return projectsCache;
            })
            .finally(function () {
                projectsFetchPromise = null;
            });
        return projectsFetchPromise;
    };

    var runProjectSearch = function (query) {
        var searchValue = String(query || '').trim();
        if (projectSearchInput) {
            projectSearchInput.setAttribute('aria-busy', 'true');
        }
        return ensureProjectsLoaded(false)
            .then(function (rows) {
                renderProjectList(filterProjectsLocally(searchValue, rows));
            })
            .catch(function (error) {
                handleApiError(error, t('projectSearchFailed', 'Project search failed.'));
            })
            .finally(function () {
                if (projectSearchInput) {
                    projectSearchInput.setAttribute('aria-busy', 'false');
                }
            });
    };

    var createProjectViaApi = function () {
        if (!createProjectFormEl) {
            return Promise.resolve();
        }

        var formData = new FormData(createProjectFormEl);
        var payload = {
            name: String(formData.get('name') || '').trim(),
            description: String(formData.get('description') || '').trim(),
            visibility: String(formData.get('visibility') || 'private').trim() || 'private'
        };

        if (payload.name === '') {
            notify('warning', t('projectNameRequired', 'Project name is required.'));
            return Promise.resolve();
        }

        if (createProjectSubmitEl) {
            createProjectSubmitEl.disabled = true;
        }

        return api.createProject(payload)
            .then(function (response) {
                var createdProject = extractSingleProject(response);
                notify('success', buildFlashMessage(response, t('projectCreatedSuccess', 'Project created successfully.')));
                createProjectFormEl.reset();
                closeModal(createModal);
                if (projectSearchInput) {
                    projectSearchInput.value = '';
                }
                if (createdProject && createdProject.id > 0) {
                    projectsCache = [createdProject].concat(projectsCache.filter(function (project) {
                        return parseInt(project.id || 0, 10) !== createdProject.id;
                    }));
                    projectsLoadedOnce = true;
                    renderProjectsEverywhere(projectsCache);
                }
                return ensureProjectsLoaded(true).then(function (rows) {
                    renderProjectsEverywhere(rows);
                });
            })
            .catch(function (error) {
                handleApiError(error, t('projectCreateFailed', 'Project could not be created.'));
            })
            .finally(function () {
                if (createProjectSubmitEl) {
                    createProjectSubmitEl.disabled = false;
                }
            });
    };

    var uploadProjectFileViaApi = function () {
        if (!projectFilesFormEl || !projectFileInputEl) {
            return Promise.resolve();
        }

        var selectedFile = projectFileInputEl.files && projectFileInputEl.files[0] ? projectFileInputEl.files[0] : null;
        var validationMessage = validateProjectFile(selectedFile);
        if (validationMessage) {
            notify('warning', validationMessage);
            return Promise.resolve();
        }

        if (projectFilesSubmitEl) {
            projectFilesSubmitEl.disabled = true;
        }

        return api.uploadProjectFile(selectedFile, 0)
            .then(function (payload) {
                var uploadedFiles = extractProjectFiles(payload);
                if (uploadedFiles.length) {
                    projectFilesCache = mergeProjectFiles(uploadedFiles.concat(projectFilesCache));
                }
                notify('success', buildFlashMessage(payload, t('fileUploadSuccess', 'File uploaded and attached.')));
                projectFilesFormEl.reset();
                var nameEl = document.getElementById('uploaded-file-name');
                if (nameEl) { nameEl.textContent = ''; }
                projectFileInputEl.classList.remove('has-file');

                return loadDashboardData();
            })
            .catch(function (error) {
                var status = error && error.status ? error.status : 0;
                if (status === 401) {
                    notify('warning', t('sessionExpired', 'Session expired. Please sign in again.'));
                    window.setTimeout(function () {
                        window.location.reload();
                    }, 600);
                    return;
                }
                if (status === 403) {
                    notify('warning', t('projectFileForbidden', 'You do not have permission for this upload.'));
                    return;
                }
                if (status === 422) {
                    notify('warning', getErrorMessage(error, t('projectFileInvalidType', 'File type not allowed. Allowed types are PDF, TXT, DOCX, CSV, XLSX, JPG, JPEG and PNG.')));
                    return;
                }
                if (status === 413) {
                    notify('alert', t('projectFileTooLargeServer', 'File is too large.'));
                    return;
                }
                handleApiError(error, t('fileUploadFailed', 'File upload failed.'));
            })
            .finally(function () {
                if (projectFilesSubmitEl) {
                    projectFilesSubmitEl.disabled = false;
                }
            });
    };

    var renderContentMethods = function (rows) {
        if (!contentMethodsListEl) {
            return;
        }
        contentMethodsListEl.innerHTML = '';
        if (!Array.isArray(rows) || !rows.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noMethodsAvailableChannels', 'No methods available from channels.');
            contentMethodsListEl.appendChild(empty);
            return;
        }

        rows.slice(0, 8).forEach(function (row) {
            var method = row && typeof row === 'object' ? row : {};
            var id = parseInt(method.id || 0, 10) || 0;
            if (id <= 0) {
                return;
            }

            var card = document.createElement('div');
            card.className = 'kh-content-item';

            var title = document.createElement('strong');
            title.textContent = String(method.title || ('Method #' + id));
            card.appendChild(title);

            var meta = document.createElement('small');
            meta.textContent = t('idLabel', 'ID') + ': ' + id;
            card.appendChild(meta);

            var shortDescription = String(method.short_description || method.description_short || '');
            var description = String(method.description || '');
            var imageUrl = resolveAssetUrl(method.image || method.thumbnail || method.logo || '');
            if (shortDescription) {
                var shortDesc = document.createElement('p');
                shortDesc.className = 'kh-meta';
                setLimitedHtml(shortDesc, shortDescription);
                card.appendChild(shortDesc);
            }
            if (description) {
                var desc = document.createElement('p');
                desc.className = 'kh-meta';
                setLimitedHtml(desc, description);
                card.appendChild(desc);
            }
            if (imageUrl) {
                var image = document.createElement('img');
                image.src = imageUrl;
                image.alt = String(method.title || 'Method image');
                image.style.maxWidth = '120px';
                image.style.height = 'auto';
                image.style.borderRadius = '8px';
                image.style.display = 'block';
                image.style.marginBottom = '8px';
                card.appendChild(image);
            }

            var addForm = document.createElement('form');
            addForm.method = 'post';
            addForm.action = '';
            addForm.style.marginTop = '8px';

            var actionInput = document.createElement('input');
            actionInput.type = 'hidden';
            actionInput.name = 'project_action';
            actionInput.value = 'add_method';
            addForm.appendChild(actionInput);

            var projectInput = document.createElement('input');
            projectInput.type = 'hidden';
            projectInput.name = 'project_id';
            projectInput.value = String(projectId);
            addForm.appendChild(projectInput);

            var methodInput = document.createElement('input');
            methodInput.type = 'hidden';
            methodInput.name = 'content_method_id';
            methodInput.value = String(id);
            addForm.appendChild(methodInput);

            var addButton = document.createElement('button');
            addButton.className = 'btn btn-secondary';
            addButton.type = 'submit';
            addButton.textContent = t('addToProject', 'Add to project');
            addForm.appendChild(addButton);

            card.appendChild(addForm);
            contentMethodsListEl.appendChild(card);
        });

        bindProjectActionForms();
    };

    var renderCommentsList = function (rows) {
        if (!commentsListEl) {
            return;
        }
        commentsListEl.innerHTML = '';
        if (!Array.isArray(rows) || !rows.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noCommentsYet', 'No comments yet.');
            commentsListEl.appendChild(empty);
            return;
        }

        rows.forEach(function (comment) {
            var commentId = parseInt(comment.id || 0, 10) || 0;
            var body = String(comment.body || '').trim();
            if (commentId <= 0 || body === '') {
                return;
            }

            var commentUser = comment.user && typeof comment.user === 'object' ? comment.user : {};
            var authorName = String(
                comment.user_name
                || comment.user_display_name
                || comment.author_name
                || comment.display_name
                || comment.name
                || commentUser.name
                || ''
            ).trim();
            var authorEmail = String(
                comment.email
                || comment.user_email
                || comment.author_email
                || commentUser.email
                || ''
            ).trim();
            var commentDateRaw = String(comment.updated_at || comment.created_at || '').trim();
            var commentDate = '';
            if (commentDateRaw !== '') {
                var parsedDate = Date.parse(commentDateRaw);
                if (!Number.isNaN(parsedDate)) {
                    commentDate = new Date(parsedDate).toLocaleString();
                } else {
                    commentDate = commentDateRaw;
                }
            }

            var wrapper = document.createElement('div');
            wrapper.className = 'ih-comment-item';

            if (authorName !== '' || authorEmail !== '' || commentDate !== '') {
                var meta = document.createElement('div');
                meta.className = 'ih-comment-meta';

                var author = authorName !== '' ? authorName : authorEmail;
                if (author !== '') {
                    var authorEl = document.createElement('span');
                    authorEl.className = 'ih-comment-author';
                    authorEl.textContent = author;
                    meta.appendChild(authorEl);
                }

                if (authorName !== '' && authorEmail !== '') {
                    var emailEl = document.createElement('span');
                    emailEl.className = 'ih-comment-email';
                    emailEl.textContent = authorEmail;
                    meta.appendChild(emailEl);
                }

                if (commentDate !== '') {
                    var dateEl = document.createElement('span');
                    dateEl.className = 'ih-comment-date';
                    dateEl.textContent = commentDate;
                    meta.appendChild(dateEl);
                }

                wrapper.appendChild(meta);
            }

            var text = document.createElement('p');
            text.className = 'ih-comment-body';
            text.textContent = body;
            wrapper.appendChild(text);

            if (canManageProjectComments()) {
                var form = document.createElement('form');
                form.method = 'post';
                form.action = '';

                var action = document.createElement('input');
                action.type = 'hidden';
                action.name = 'project_action';
                action.value = 'delete_comment';
                form.appendChild(action);

                var pid = document.createElement('input');
                pid.type = 'hidden';
                pid.name = 'project_id';
                pid.value = String(projectId);
                form.appendChild(pid);

                var cid = document.createElement('input');
                cid.type = 'hidden';
                cid.name = 'comment_id';
                cid.value = String(commentId);
                form.appendChild(cid);

                var button = document.createElement('button');
                button.className = 'btn btn-delete';
                button.type = 'submit';
                button.textContent = t('deleteComment', 'Delete comment');
                form.appendChild(button);

                wrapper.appendChild(form);
            }
            commentsListEl.appendChild(wrapper);
        });

        bindProjectActionForms();
    };

    var resolveCurrentMemberEntry = function (members) {
        if (!Array.isArray(members) || !members.length) {
            return null;
        }
        for (var i = 0; i < members.length; i += 1) {
            var member = members[i];
            if (!member || typeof member !== 'object') {
                continue;
            }
            var memberEmail = String(member.email || (member.user && member.user.email) || '').trim().toLowerCase();
            var memberUserId = String(member.user_id || member.id || (member.user && member.user.id) || '').trim();
            if (currentUserEmail !== '' && memberEmail !== '' && currentUserEmail === memberEmail) {
                return member;
            }
            if (currentUserId !== '' && memberUserId !== '' && currentUserId === memberUserId) {
                return member;
            }
        }
        return null;
    };

    var renderProjectInviteBanner = function (members, project) {
        if (!projectInviteBannerEl) {
            return;
        }
        var memberEntry = resolveCurrentMemberEntry(members);
        var status = memberEntry ? String(memberEntry.status || 'active').toLowerCase() : getProjectMembershipStatus(project);
        var normalizedProject = normalizeProjectItem(project);
        var isJoinablePublic = !memberEntry && isPublicJoinableProject(normalizedProject);

        projectInviteBannerEl.innerHTML = '';
        if (status !== 'invited' && !isJoinablePublic) {
            projectInviteBannerEl.style.display = 'none';
            return;
        }

        var text = document.createElement('p');
        text.className = 'kh-invite-banner-text';
        text.textContent = isJoinablePublic
            ? t('publicJoinBannerText', 'Join this public project before opening and editing shared content.')
            : t('inviteBannerText', 'You have been invited to this project. Please accept the invitation to actively participate.');

        var actions = document.createElement('div');
        actions.className = 'kh-actions';

        var acceptBtn = document.createElement('button');
        acceptBtn.type = 'button';
        acceptBtn.className = 'btn btn-primary';
        acceptBtn.textContent = isJoinablePublic
            ? t('projectJoinButton', 'Join project')
            : t('inviteAcceptButton', 'Accept invitation');
        acceptBtn.addEventListener('click', function () {
            acceptBtn.disabled = true;
            (isJoinablePublic ? api.joinPublicProjectById(projectId) : api.acceptProjectInvite())
                .then(function () {
                    notify('success', isJoinablePublic
                        ? t('projectJoinSuccess', 'Project joined.')
                        : t('inviteAcceptSuccess', 'Invitation accepted.'));
                    return loadDashboardData();
                })
                .catch(function (error) {
                    handleApiError(error, isJoinablePublic
                        ? t('projectJoinFailed', 'Project could not be joined.')
                        : t('inviteAcceptFailed', 'Invitation could not be accepted.'));
                })
                .finally(function () {
                    acceptBtn.disabled = false;
                });
        });

        actions.appendChild(acceptBtn);
        projectInviteBannerEl.appendChild(text);
        projectInviteBannerEl.appendChild(actions);
        projectInviteBannerEl.style.display = '';
    };

    var buildMembersTable = function (rows) {
        if (!Array.isArray(rows) || !rows.length) {
            return null;
        }
        if (!membersListEl) {
            return;
        }
        if (!canManageMembers()) {
            var denied = document.createElement('p');
            denied.className = 'kh-meta';
            denied.textContent = t('membersPermissionDenied', 'Only project owners and admins can manage members.');
            return denied;
        }

        var table = document.createElement('table');
        table.className = 'kh-members-table';
        var thead = document.createElement('thead');
        var headRow = document.createElement('tr');
        [t('memberTableName', 'Mitglied'), t('memberTableRole', 'Rolle'), t('memberTableStatus', 'Status'), t('memberTableActions', 'Aktionen')].forEach(function (label) {
            var th = document.createElement('th');
            th.textContent = label;
            headRow.appendChild(th);
        });
        thead.appendChild(headRow);
        table.appendChild(thead);
        var tbody = document.createElement('tbody');

        rows.forEach(function (member) {
            var memberUserId = parseInt(member.user_id || member.id || 0, 10) || 0;
            if (memberUserId <= 0) {
                return;
            }
            var memberName = String(member.name || member.email || ('User #' + memberUserId));
            var memberEmail = String(member.email || (member.user && member.user.email) || '').trim();
            var memberRole = String(member.role || 'project-cooperator');
            var memberStatus = String(member.status || 'active');
            var isOwner = memberRole === 'project-owner';

            var row = document.createElement('tr');

            var nameCell = document.createElement('td');
            nameCell.className = 'kh-member-name';
            var nameWrap = document.createElement('div');
            nameWrap.className = 'kh-member-name-wrap';
            var namePrimary = document.createElement('div');
            namePrimary.className = 'kh-member-name-primary';
            namePrimary.textContent = memberName;
            nameWrap.appendChild(namePrimary);
            if (memberEmail && memberEmail.toLowerCase() !== String(memberName || '').trim().toLowerCase()) {
                var nameSecondary = document.createElement('div');
                nameSecondary.className = 'kh-member-name-secondary';
                nameSecondary.textContent = memberEmail;
                nameWrap.appendChild(nameSecondary);
            }
            nameCell.appendChild(nameWrap);
            row.appendChild(nameCell);

            var roleCell = document.createElement('td');
            var roleSelect = document.createElement('select');
            roleSelect.name = 'role';
            ['project-cooperator', 'project-admin', 'project-owner'].forEach(function (roleOption) {
                var option = document.createElement('option');
                option.value = roleOption;
                option.textContent = roleLabel(roleOption);
                if (roleOption === memberRole) option.selected = true;
                roleSelect.appendChild(option);
            });
            roleCell.appendChild(roleSelect);
            row.appendChild(roleCell);

            var statusCell = document.createElement('td');
            var statusSelect = document.createElement('select');
            statusSelect.name = 'status';
            ['active', 'invited'].forEach(function (statusOption) {
                var option = document.createElement('option');
                option.value = statusOption;
                option.textContent = statusOption === 'active'
                    ? t('memberStatusActive', 'Active')
                    : t('memberStatusInvited', 'Invited');
                if (statusOption === memberStatus) option.selected = true;
                statusSelect.appendChild(option);
            });
            statusCell.appendChild(statusSelect);
            row.appendChild(statusCell);

            var actionsCell = document.createElement('td');
            actionsCell.className = 'kh-members-actions';
            var updateButton = document.createElement('button');
            updateButton.className = 'btn btn-primary';
            updateButton.type = 'button';
            updateButton.textContent = t('saveRole', 'Save role');
            updateButton.addEventListener('click', function () {
                updateButton.disabled = true;
                apiRequest('PATCH', baseEndpoint + '/members/' + memberUserId, {
                    role: String(roleSelect.value || 'project-cooperator').trim() || 'project-cooperator',
                    status: String(statusSelect.value || 'active').trim() || 'active'
                })
                    .then(function () {
                        notify('success', t('memberSaved', 'Rolle gespeichert.'));
                        return loadDashboardData();
                    })
                    .catch(function (error) {
                        handleApiError(error, t('requestFailed', 'Action could not be completed.'));
                    })
                    .finally(function () {
                        updateButton.disabled = false;
                    });
            });

            var removeButton = document.createElement('button');
            removeButton.className = 'btn btn-delete';
            removeButton.type = 'button';
            removeButton.textContent = t('removeMember', 'Remove member');
            if (isOwner) removeButton.disabled = true;
            removeButton.addEventListener('click', function () {
                if (isOwner) return;
                if (!window.confirm(t('removeMember', 'Remove member') + '?')) return;
                removeButton.disabled = true;
                apiRequest('DELETE', baseEndpoint + '/members/' + memberUserId)
                    .then(function () {
                        notify('success', t('memberRemoved', 'Mitglied entfernt.'));
                        return loadDashboardData();
                    })
                    .catch(function (error) {
                        handleApiError(error, t('requestFailed', 'Action could not be completed.'));
                    })
                    .finally(function () {
                        removeButton.disabled = false;
                    });
            });
            actionsCell.appendChild(updateButton);
            actionsCell.appendChild(removeButton);
            row.appendChild(actionsCell);
            tbody.appendChild(row);
        });

        table.appendChild(tbody);
        return table;
    };

    var renderMembersList = function (rows) {
        if (!membersListEl) {
            return;
        }
        membersListEl.innerHTML = '';
        if (!Array.isArray(rows) || !rows.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noMembersFound', 'No members found.');
            membersListEl.appendChild(empty);
            return;
        }

        var invitedRows = [];
        var activeRows = [];
        rows.forEach(function (member) {
            var status = String((member && member.status) || 'active').toLowerCase();
            if (status === 'invited') {
                invitedRows.push(member);
                return;
            }
            activeRows.push(member);
        });

        var appendSection = function (title, sectionRows) {
            if (!sectionRows.length) {
                return;
            }
            var section = document.createElement('section');
            section.className = 'kh-members-section';
            var heading = document.createElement('h5');
            heading.className = 'kh-members-section-title';
            heading.textContent = title;
            section.appendChild(heading);
            var table = buildMembersTable(sectionRows);
            if (table) {
                section.appendChild(table);
            }
            membersListEl.appendChild(section);
        };

        appendSection(t('membersInvitedTitle', 'Open invitations'), invitedRows);
        appendSection(t('membersActiveTitle', 'Active members'), activeRows);

        if (!membersListEl.children.length) {
            var noRows = document.createElement('p');
            noRows.className = 'kh-meta';
            noRows.textContent = t('noMembersFound', 'No members found.');
            membersListEl.appendChild(noRows);
        }
    };

    var loadDashboardData = function (options) {
        if (projectId <= 0) {
            return Promise.resolve();
        }
        var optionsConfig = options && typeof options === 'object' ? options : {};
        var useOverlay = optionsConfig.useOverlay !== false;

        var contentMethodsRequest = contentMethodsListEl
            ? api.listAddedMethodsFromSearch()
            : Promise.resolve([]);

        var quietLoad = { useOverlay: false };
        if (useOverlay) {
            showLoadingOverlay();
        }

        return Promise.allSettled([
            api.getProject(quietLoad),
            api.listMembers(quietLoad),
            api.listMethods(quietLoad),
            api.listResults(quietLoad),
            api.listComments(quietLoad),
            contentMethodsRequest,
            api.listProjectLinks()
        ])
            .then(function (responses) {
                var projectResult = responses[0];
                var membersResult = responses[1];
                var itemsResult = responses[2];
                var resultsResult = responses[3];
                var commentsResult = responses[4];
                var contentMethodsResult = responses[5];
                var linksResult = responses[6];

                var projectPayload = projectResult && projectResult.status === 'fulfilled' ? (projectResult.value || {}) : {};
                var project = projectResult && projectResult.status === 'fulfilled' ? (extractSingle(projectPayload) || {}) : {};
                var members = membersResult && membersResult.status === 'fulfilled' ? extractRows(membersResult.value) : [];
                var items = itemsResult && itemsResult.status === 'fulfilled' ? extractRows(itemsResult.value) : [];
                var results = resultsResult && resultsResult.status === 'fulfilled' ? extractRows(resultsResult.value) : [];
                var comments = commentsResult && commentsResult.status === 'fulfilled' ? extractRows(commentsResult.value) : [];
                var contentMethods = contentMethodsResult && contentMethodsResult.status === 'fulfilled' ? extractRows(contentMethodsResult.value) : [];
                var links = linksResult && linksResult.status === 'fulfilled' ? extractRows(linksResult.value) : [];

                if (projectResult && projectResult.status === 'rejected') {
                    handleApiError(projectResult.reason, t('dashboardLoadFailed', 'Project dashboard could not be loaded.'));
                }

                if (projectNameEl) {
                    projectNameEl.textContent = String(project.name || t('untitledProject', 'Untitled project'));
                }
                if (projectDescriptionEl) {
                    projectDescriptionEl.textContent = String(project.description || t('noDescriptionAvailable', 'No description available.'));
                }
                if (projectVisibilityEl) {
                    projectVisibilityEl.textContent = String(project.visibility || 'private');
                }
                currentProjectRole = resolveCurrentProjectRole(project, members);
                canDeleteProjectFiles = currentProjectRole === 'project-owner' || currentProjectRole === 'project-admin';
                var membershipStatus = getProjectMembershipStatus(project);
                if (projectRoleEl) {
                    projectRoleEl.textContent = membershipStatus === 'invited'
                        ? t('memberStatusInvited', 'Invited')
                        : roleLabel(currentProjectRole);
                }
                updateProjectRoleControls();
                updateCommentFormVisibility();
                updateProjectCover(project);

                if (statsMembersEl) statsMembersEl.textContent = String(members.length || 0);
                if (statsItemsEl) statsItemsEl.textContent = String(items.length || 0);

                membersCache = Array.isArray(members) ? members : [];
                methodsCache = items.map(normalizeMethodItem).filter(function (item) { return !!item; });
                resultsCache = results.map(normalizeProjectResult).filter(function (item) { return !!item; });
                var methodCount = methodsCache.length;
                if (statsMethodsEl) statsMethodsEl.textContent = String(methodCount);
                updateCreateResultButtonState();

                projectFilesCache = mergeProjectFiles(extractProjectFiles(projectPayload).concat(extractProjectFiles(project)));
                projectLinksCache = mergeProjectLinks(links);
                renderProjectFiles();
                renderMethodList(methodsCache);
                renderProjectResults(resultsCache);
                renderCommentsList(comments);
                renderMembersList(members);
                renderProjectInviteBanner(members, project);
                renderContentMethods(contentMethods);
                updateSettingsFormFromProject(project);
            })
            .finally(function () {
                if (useOverlay) {
                    hideLoadingOverlay();
                }
            });
    };

    var loadResults = function () {
        if (projectId <= 0) {
            return Promise.resolve();
        }
        return api.listResults()
            .then(function (payload) {
                resultsCache = extractRows(payload).map(normalizeProjectResult).filter(function (item) { return !!item; });
                renderProjectResults(resultsCache);
            })
            .catch(function (error) {
                handleApiError(error, t('couldNotLoadResults', 'Could not load results.'));
            });
    };

    var getErrorMessage = function (error, fallback) {
        var payload = error && error.payload ? error.payload : null;
        return (payload && (payload.message || (payload.data && payload.data.message))) || fallback;
    };

    var extractValidationErrors = function (error) {
        var payload = error && error.payload ? error.payload : null;
        var errors = payload && payload.errors && typeof payload.errors === 'object'
            ? payload.errors
            : (payload && payload.data && payload.data.errors && typeof payload.data.errors === 'object'
                ? payload.data.errors
                : null);
        if (!errors) {
            return {};
        }
        var normalized = {};
        Object.keys(errors).forEach(function (key) {
            var value = errors[key];
            var normalizedKey = String(key || '').replace(/^result_payload\./, '');
            if (Array.isArray(value)) {
                normalized[normalizedKey] = String(value[0] || '');
                return;
            }
            normalized[normalizedKey] = String(value || '');
        });
        return normalized;
    };

    var handleApiError = function (error, fallbackMessage) {
        var status = error && error.status ? error.status : 0;
        if (status === 401) {
            notify('warning', t('sessionExpired', 'Session expired. Please sign in again.'));
            window.setTimeout(function () {
                window.location.reload();
            }, 600);
            return;
        }
        if (status === 403) {
            var message = getErrorMessage(error, fallbackMessage || t('requestFailed', 'Action could not be completed.'));
            if (currentMethod || (editorEl && editorEl.getAttribute('aria-hidden') === 'false')) {
                setEditorReadOnly(true, message);
            }
            notify('warning', message);
            return;
        }
        notify('alert', getErrorMessage(error, fallbackMessage));
    };

    var submitProjectFormAjax = function (form, submitter) {
        var formData = new FormData(form);
        var action = String(formData.get('project_action') || '');
        var button = submitter && submitter.tagName === 'BUTTON' ? submitter : null;
        if (button) {
            button.disabled = true;
        }

        var endpointForProject = function (targetProjectId) {
            var id = parseInt(targetProjectId || 0, 10) || 0;
            if (!baseEndpoint) {
                return '';
            }
            if (id <= 0) {
                return baseEndpoint;
            }
            if (/\/projects\/\d+$/i.test(baseEndpoint)) {
                return baseEndpoint.replace(/\/projects\/\d+$/i, '/projects/' + id);
            }
            return baseEndpoint.replace(/\/+$/, '') + '/' + id;
        };

        var parseFetchJsonResponse = function (response) {
            return response.text().then(function (text) {
                var parsed = null;
                try {
                    parsed = text ? JSON.parse(text) : null;
                } catch (e) {
                    parsed = null;
                }
                if (!response.ok) {
                    var error = new Error('HTTP ' + response.status);
                    error.status = response.status;
                    error.payload = parsed || {};
                    throw error;
                }
                return parsed || {};
            });
        };

        var submitActionViaApi = function () {
            var targetProjectId = parseInt(formData.get('project_id') || projectId || 0, 10) || 0;
            var endpoint = endpointForProject(targetProjectId);
            var memberUserId = parseInt(formData.get('member_user_id') || 0, 10) || 0;
            var methodId = parseInt(formData.get('method_id') || formData.get('item_id') || 0, 10) || 0;
            var contentMethodId = parseInt(formData.get('content_method_id') || 0, 10) || 0;
            var commentId = parseInt(formData.get('comment_id') || 0, 10) || 0;
            var fileId = parseInt(formData.get('file_id') || 0, 10) || 0;

            if (action === 'update') {
                return apiRequest('PATCH', endpoint, {
                    name: String(formData.get('name') || '').trim(),
                    description: String(formData.get('description') || '').trim(),
                    visibility: String(formData.get('visibility') || 'private').trim() || 'private'
                });
            }
            if (action === 'delete') {
                return apiRequest('DELETE', endpoint);
            }
            if (action === 'leave') {
                return apiRequest('POST', endpoint + '/leave', {});
            }
            if (action === 'invite_member') {
                return apiRequest('POST', endpoint + '/members/invite', {
                    email: String(formData.get('email') || '').trim(),
                    role: String(formData.get('role') || 'project-cooperator').trim() || 'project-cooperator'
                });
            }
            if (action === 'update_member') {
                return apiRequest('PATCH', endpoint + '/members/' + memberUserId, {
                    role: String(formData.get('role') || 'project-cooperator').trim() || 'project-cooperator',
                    status: String(formData.get('status') || 'active').trim() || 'active'
                });
            }
            if (action === 'remove_member') {
                return apiRequest('DELETE', endpoint + '/members/' + memberUserId);
            }
            if (action === 'add_method') {
                return apiRequest('POST', endpoint + '/items', { content_method_id: contentMethodId });
            }
            if (action === 'remove_method' || action === 'remove_item') {
                return apiRequest('DELETE', endpoint + '/items/' + methodId);
            }
            if (action === 'add_comment') {
                return apiRequest('POST', endpoint + '/comments', { body: String(formData.get('body') || '').trim() });
            }
            if (action === 'delete_comment') {
                return apiRequest('DELETE', endpoint + '/comments/' + commentId);
            }
            if (action === 'add_reaction') {
                return apiRequest('POST', endpoint + '/comments/' + commentId + '/reactions', {
                    reaction: String(formData.get('reaction') || '').trim()
                });
            }
            if (action === 'delete_reaction') {
                var reaction = encodeURIComponent(String(formData.get('reaction') || '').trim());
                return apiRequest('DELETE', endpoint + '/comments/' + commentId + '/reactions/' + reaction);
            }
            if (action === 'remove_file') {
                return apiRequest('DELETE', endpoint + '/files/' + fileId);
            }
            if (action === 'upload_cover') {
                var image = formData.get('cover_image');
                if (!(image instanceof File) || !image.name) {
                    return Promise.reject({ status: 422, payload: { message: t('projectFileRequired', 'Please select a file.') } });
                }
                var headers = { Accept: 'application/json' };
                if (bearerToken !== '') {
                    headers.Authorization = 'Bearer ' + bearerToken;
                }
                var body = new FormData();
                body.append('image', image);
                return fetch(endpoint + '/cover-image', {
                    method: 'POST',
                    headers: headers,
                    body: body
                }).then(parseFetchJsonResponse);
            }

            return Promise.reject({ status: 400, payload: { message: 'Unsupported action: ' + action } });
        };

        showLoadingOverlay();
        submitActionViaApi()
            .then(function (response) {
                var payload = response && typeof response === 'object' ? response : {};
                var isOk = !!(payload && payload.ok);
                if (!isOk) {
                    var errorMessage = buildFlashMessage(payload, t('requestFailed', 'Action could not be completed.'));
                    notify('alert', errorMessage);
                    return;
                }

                var successMessage = buildFlashMessage(payload, t('actionSucceeded', 'Action completed successfully.'));
                notify('success', successMessage);

                if (action === 'leave' || action === 'delete') {
                    window.setTimeout(function () {
                        window.location.href = listUrl;
                    }, 500);
                    return;
                }

                if (action === 'add_method') {
                    return Promise.all([loadMethods(), loadDashboardData({ useOverlay: false })])
                        .catch(function () {
                            window.location.reload();
                        });
                }

                if (action === 'remove_method') {
                    var removedMethodId = parseInt(formData.get('method_id') || formData.get('item_id') || 0, 10) || 0;
                    if (removedMethodId > 0) {
                        removeMethodFromLocalState(removedMethodId);
                    }
                    loadResults();
                    syncMethodsAfterRemoval();
                    return;
                }

                if (
                    action === 'upload_cover'
                    || action === 'update'
                    || action === 'add_comment'
                    || action === 'delete_comment'
                    || action === 'invite_member'
                    || action === 'update_member'
                    || action === 'remove_member'
                    || action === 'remove_file'
                    || action === 'add_reaction'
                    || action === 'delete_reaction'
                ) {
                    return loadDashboardData({ useOverlay: false })
                        .catch(function (error) {
                            handleApiError(error, t('dashboardRefreshFailed', 'Project dashboard could not be refreshed.'));
                        });
                }

                return loadDashboardData({ useOverlay: false })
                    .catch(function (error) {
                        handleApiError(error, t('dashboardRefreshFailed', 'Project dashboard could not be refreshed.'));
                    });
            })
            .catch(function (error) {
                notify('alert', getErrorMessage(error, t('requestFailed', 'Action could not be completed.')));
            })
            .finally(function () {
                hideLoadingOverlay();
                if (button) {
                    button.disabled = false;
                }
            });
    };

    var bindProjectActionForms = function () {
        var actionInputs = document.querySelectorAll('form input[name="project_action"]');
        actionInputs.forEach(function (actionInput) {
            var form = actionInput.form;
            if (!form || form.dataset.khProjectAjaxBound === '1') {
                return;
            }
            if (form.id === 'kh-create-project-form') {
                return;
            }
            form.dataset.khProjectAjaxBound = '1';
            form.addEventListener('submit', function (event) {
                event.preventDefault();
                submitProjectFormAjax(form, event.submitter || null);
            });
        });
    };

    var renderSearchHint = function (message) {
        if (!contentSearchResultsEl) {
            return;
        }
        contentSearchResultsEl.innerHTML = '';
        var p = document.createElement('p');
        p.className = 'kh-meta';
        p.textContent = message;
        contentSearchResultsEl.appendChild(p);
    };

    var setEditorError = function (message) {
        if (!editorErrorEl) {
            return;
        }
        if (message) {
            editorErrorEl.style.display = 'block';
            editorErrorEl.textContent = message;
        } else {
            editorErrorEl.style.display = 'none';
            editorErrorEl.textContent = '';
        }
    };

    var updateEditorStatusChip = function (status) {
        if (!statusChipEl) {
            return;
        }
        statusChipEl.textContent = status || 'empty';
    };

    var setEditorReadOnly = function (isReadOnly, message) {
        editorReadOnly = !!isReadOnly;
        if (resultTitleEl) resultTitleEl.disabled = editorReadOnly;
        if (resultShortDescriptionEl) resultShortDescriptionEl.disabled = editorReadOnly;
        if (resultAssignedUserEl) resultAssignedUserEl.disabled = editorReadOnly;
        if (resultMethodsEl) resultMethodsEl.disabled = editorReadOnly;
        if (resultImageSelectEl) resultImageSelectEl.disabled = editorReadOnly;
        if (resultFilesInputEl) resultFilesInputEl.disabled = editorReadOnly;
        if (resultDescriptionEl) {
            resultDescriptionEl.setAttribute('contenteditable', editorReadOnly ? 'false' : 'true');
        }
        if (resultStatusEl) resultStatusEl.disabled = editorReadOnly;
        if (saveBtn) saveBtn.disabled = editorReadOnly || pendingUploads > 0;
        if (resultDeleteBtn) resultDeleteBtn.disabled = editorReadOnly;

        if (templateSectionsEl) {
            var controls = templateSectionsEl.querySelectorAll('input, textarea, select, button');
            controls.forEach(function (control) {
                if (control && control.type !== 'hidden') {
                    control.disabled = editorReadOnly;
                }
            });
        }

        if (editorReadOnly && message) {
            setEditorError(message);
        }
    };

    var updateSaveButtonsState = function () {
        var disabled = editorReadOnly || pendingUploads > 0;
        if (saveBtn) saveBtn.disabled = disabled;
    };

    var extractTemplateSectionsFromSchema = function (schema) {
        var sections = [];
        if (!schema || typeof schema !== 'object') {
            return sections;
        }

        var pushField = function (target, field, sectionLabel) {
            if (!field || typeof field !== 'object') {
                return;
            }
            var key = String(field.key || field.name || '').trim();
            if (!key) {
                return;
            }
            target.push({
                key: key,
                label: String(field.label || key),
                field: String(field.field || field.type || 'textarea').toLowerCase(),
                options: Array.isArray(field.options) ? field.options : [],
                placeholder: String(field.placeholder || ''),
                help: String(field.help || ''),
                accept: String(field.accept || ''),
                section: sectionLabel || null
            });
        };

        if (Array.isArray(schema.sections)) {
            schema.sections.forEach(function (section) {
                if (!section || typeof section !== 'object') {
                    return;
                }
                var sectionLabel = String(section.label || section.title || '').trim();
                var sectionFields = [];
                if (Array.isArray(section.fields)) {
                    section.fields.forEach(function (field) {
                        pushField(sectionFields, field, sectionLabel);
                    });
                } else if (section.field && typeof section.field === 'object') {
                    pushField(sectionFields, section.field, sectionLabel);
                } else {
                    pushField(sectionFields, section, sectionLabel);
                }
                if (sectionFields.length) {
                    sections.push({
                        label: sectionLabel,
                        fields: sectionFields
                    });
                }
            });
        }

        if (!sections.length && Array.isArray(schema.fields)) {
            var rootFields = [];
            schema.fields.forEach(function (field) {
                pushField(rootFields, field, '');
            });
            if (rootFields.length) {
                sections.push({ label: '', fields: rootFields });
            }
        }

        return sections;
    };

    var normalizeFieldKind = function (value, fieldConfig) {
        var raw = String(value || 'textarea').toLowerCase();
        if (raw === 'boolean') return 'boolean';
        if (raw === 'checkbox') {
            return Array.isArray(fieldConfig && fieldConfig.options) && fieldConfig.options.length ? 'checkbox_group' : 'boolean';
        }
        if (raw === 'number' || raw === 'integer' || raw === 'float') return 'number';
        if (raw === 'choice' || raw === 'select') return 'select';
        if (raw === 'radio') return 'radio';
        if (raw === 'multi_choice' || raw === 'multiselect' || raw === 'tags') return 'multi_choice';
        if (raw === 'image') return 'image';
        if (raw === 'file') return 'file';
        if (raw === 'canvas_freeform') return 'canvas_freeform';
        if (raw === 'json' || raw === 'object') return 'json';
        if (raw === 'text') return 'text';
        return 'textarea';
    };

    var normalizeOption = function (optionRaw) {
        if (optionRaw && typeof optionRaw === 'object') {
            var optionValue = optionRaw.value != null ? optionRaw.value : optionRaw.key;
            var optionLabel = optionRaw.label != null ? optionRaw.label : optionValue;
            return {
                value: String(optionValue != null ? optionValue : ''),
                label: String(optionLabel != null ? optionLabel : '')
            };
        }
        return {
            value: String(optionRaw != null ? optionRaw : ''),
            label: String(optionRaw != null ? optionRaw : '')
        };
    };

    var deepClone = function (value) {
        if (value == null) {
            return value;
        }
        try {
            return JSON.parse(JSON.stringify(value));
        } catch (e) {
            return value;
        }
    };

    var getDefaultValueForField = function (fieldConfig) {
        var kind = normalizeFieldKind(fieldConfig.field, fieldConfig);
        if (kind === 'number') return '';
        if (kind === 'select' || kind === 'radio' || kind === 'text' || kind === 'textarea' || kind === 'json') return '';
        if (kind === 'multi_choice' || kind === 'checkbox_group') return [];
        if (kind === 'boolean') return false;
        if (kind === 'canvas_freeform') return { widgets: [], links: [] };
        if (kind === 'image' || kind === 'file') return null;
        return '';
    };

    var createFormStateFromSchema = function (schema, payload) {
        var state = payload && typeof payload === 'object' ? deepClone(payload) : {};
        if (!state || typeof state !== 'object' || Array.isArray(state)) {
            state = {};
        }
        var sections = extractTemplateSectionsFromSchema(schema);
        sections.forEach(function (section) {
            section.fields.forEach(function (fieldConfig) {
                var key = String(fieldConfig.key || '').trim();
                if (!key) {
                    return;
                }
                if (!Object.prototype.hasOwnProperty.call(state, key)) {
                    state[key] = getDefaultValueForField(fieldConfig);
                }
            });
        });
        return state;
    };

    var clearFieldErrors = function () {
        fieldErrors = {};
        if (!templateSectionsEl) {
            return;
        }
        var errorNodes = templateSectionsEl.querySelectorAll('[data-template-error-key]');
        errorNodes.forEach(function (node) {
            node.textContent = '';
            node.style.display = 'none';
        });
    };

    var applyFieldErrors = function (nextErrors) {
        clearFieldErrors();
        fieldErrors = nextErrors && typeof nextErrors === 'object' ? nextErrors : {};
        if (!templateSectionsEl) {
            return;
        }
        var getErrorNodeByKey = function (key) {
            var nodes = templateSectionsEl.querySelectorAll('[data-template-error-key]');
            for (var i = 0; i < nodes.length; i += 1) {
                if (String(nodes[i].getAttribute('data-template-error-key') || '') === String(key)) {
                    return nodes[i];
                }
            }
            return null;
        };
        Object.keys(fieldErrors).forEach(function (key) {
            var errorText = String(fieldErrors[key] || '').trim();
            if (!errorText) {
                return;
            }
            var errorEl = getErrorNodeByKey(key);
            if (errorEl) {
                errorEl.textContent = errorText;
                errorEl.style.display = 'block';
            }
        });
    };

    var clearSingleFieldError = function (key) {
        if (!key || !templateSectionsEl) {
            return;
        }
        delete fieldErrors[key];
        var errorEl = null;
        var nodes = templateSectionsEl.querySelectorAll('[data-template-error-key]');
        for (var i = 0; i < nodes.length; i += 1) {
            if (String(nodes[i].getAttribute('data-template-error-key') || '') === String(key)) {
                errorEl = nodes[i];
                break;
            }
        }
        if (errorEl) {
            errorEl.textContent = '';
            errorEl.style.display = 'none';
        }
    };

    var setFormStateValue = function (key, value) {
        formState[key] = value;
        editorDirty = true;
        clearSingleFieldError(key);
    };

    var buildUploadedFileReference = function (uploadPayload, fallbackFile) {
        var uploadedFiles = extractResultFiles(uploadPayload).concat(extractProjectFiles(uploadPayload));
        if (uploadedFiles.length) {
            return {
                file_id: parseInt(uploadedFiles[0].id || 0, 10) || null,
                url: String(uploadedFiles[0].url || ''),
                name: String(uploadedFiles[0].name || (fallbackFile && fallbackFile.name) || '')
            };
        }
        var data = extractSingle(uploadPayload);
        var fileData = data && typeof data === 'object'
            ? (data.file && typeof data.file === 'object' ? data.file : data)
            : {};
        return {
            file_id: parseInt(fileData.file_id || fileData.id || 0, 10) || null,
            url: String(fileData.url || fileData.path || ''),
            name: String(fileData.name || (fallbackFile && fallbackFile.name) || '')
        };
    };

    var resolveTemplateRenderMode = function (schema) {
        var source = schema && typeof schema === 'object' ? schema : {};
        var layout = String(source.layout || '').toLowerCase();
        var hasCanvasState = !!(source.canvas && source.canvas.initial_state && typeof source.canvas.initial_state === 'object');
        var sections = extractTemplateSectionsFromSchema(source);
        var hasCanvasField = sections.some(function (section) {
            return Array.isArray(section.fields) && section.fields.some(function (fieldConfig) {
                return normalizeFieldKind(fieldConfig.field, fieldConfig) === 'canvas_freeform';
            });
        });
        if (layout === 'miro_like_canvas' || layout === 'board' || hasCanvasState || hasCanvasField) return 'konva';
        return 'fields';
    };

    var hasKonvaBoardContent = function (candidate) {
        if (!candidate || typeof candidate !== 'object') {
            return false;
        }
        var hasNodes = Array.isArray(candidate.nodes) && candidate.nodes.length > 0;
        var hasEdges = Array.isArray(candidate.edges) && candidate.edges.length > 0;
        var hasWidgets = Array.isArray(candidate.widgets) && candidate.widgets.length > 0;
        var hasLinks = Array.isArray(candidate.links) && candidate.links.length > 0;
        var viewport = candidate.viewport && typeof candidate.viewport === 'object' ? candidate.viewport : null;
        var hasViewportOffset = !!(viewport && (
            Math.abs(parseFloat(viewport.x || 0) || 0) > 0.001 ||
            Math.abs(parseFloat(viewport.y || 0) || 0) > 0.001 ||
            Math.abs((parseFloat(viewport.scale || viewport.zoom || 1) || 1) - 1) > 0.001
        ));
        return hasNodes || hasEdges || hasWidgets || hasLinks || hasViewportOffset;
    };

    var normalizeKonvaBoardState = function (raw, fallback) {
        var rawSource = raw && typeof raw === 'object' ? raw : null;
        var fallbackSource = fallback && typeof fallback === 'object' ? fallback : null;
        var source = hasKonvaBoardContent(rawSource) ? rawSource : (fallbackSource || rawSource || {});
        var viewport = source.viewport && typeof source.viewport === 'object' ? source.viewport : {};
        var widgets = Array.isArray(source.widgets) ? source.widgets : [];
        var links = Array.isArray(source.links) ? source.links : [];
        var nodes = Array.isArray(source.nodes) && source.nodes.length ? source.nodes : widgets;
        var edges = Array.isArray(source.edges) && source.edges.length ? source.edges : links;
        return {
            viewport: {
                x: parseFloat(viewport.x || 0) || 0,
                y: parseFloat(viewport.y || 0) || 0,
                scale: Math.max(0.2, Math.min(4, parseFloat(viewport.scale || viewport.zoom || 1) || 1))
            },
            nodes: nodes.map(function (node, idx) {
                var nodeKind = String(node && (node.kind || node.type) ? (node.kind || node.type) : 'sticky');
                var isTextNode = nodeKind === 'text';
                var rawFill = String(node && (node.fill || node.background || node.color) ? (node.fill || node.background || node.color) : (isTextNode ? 'transparent' : '#fff59d'));
                var rawTextFill = String(node && (node.textFill || node.textColor || (isTextNode ? (node.fill || node.background || node.color) : null)) ? (node.textFill || node.textColor || (isTextNode ? (node.fill || node.background || node.color) : null)) : '#111827');
                return {
                    id: String(node && node.id ? node.id : ('n-' + idx + '-' + Date.now())),
                    kind: nodeKind,
                    x: parseFloat(node && node.x != null ? node.x : 80) || 80,
                    y: parseFloat(node && node.y != null ? node.y : 80) || 80,
                    width: Math.max(90, parseFloat(node && (node.width || node.w) || 220) || 220),
                    height: Math.max(60, parseFloat(node && (node.height || node.h) || 140) || 140),
                    text: String(node && (node.text != null ? node.text : (node.label != null ? node.label : (node.title != null ? node.title : (node.content != null ? node.content : ''))))),
                    fill: rawFill,
                    stroke: String(node && (node.stroke || node.borderColor) ? (node.stroke || node.borderColor) : '#d4bd57'),
                    fontSize: Math.max(10, parseFloat(node && node.fontSize || 15) || 15),
                    textFill: rawTextFill,
                    imageUrl: String(node && (node.imageUrl || node.url || node.src) ? (node.imageUrl || node.url || node.src) : '')
                };
            }),
            edges: edges.map(function (edge, idx) {
                var points = Array.isArray(edge && edge.points)
                    ? edge.points.map(function (n) { return parseFloat(n) || 0; })
                    : [];
                if (!points.length && edge && edge.start && edge.end) {
                    points = [
                        parseFloat(edge.start.x || 0) || 0,
                        parseFloat(edge.start.y || 0) || 0,
                        parseFloat(edge.end.x || 0) || 0,
                        parseFloat(edge.end.y || 0) || 0
                    ];
                }
                return {
                    id: String(edge && edge.id ? edge.id : ('e-' + idx + '-' + Date.now())),
                    kind: String(edge && edge.kind ? edge.kind : 'arrow'),
                    from: String(edge && (edge.from || edge.source) ? (edge.from || edge.source) : ''),
                    to: String(edge && (edge.to || edge.target) ? (edge.to || edge.target) : ''),
                    points: points
                };
            })
        };
    };

    var createKonvaBoardEditor = function (key, schema, fieldConfig, currentValue) {
        var canvasCfg = schema && schema.canvas && typeof schema.canvas === 'object' ? schema.canvas : {};
        var stageCfg = canvasCfg.stage && typeof canvasCfg.stage === 'object' ? canvasCfg.stage : {};
        var gridSize = parseInt(canvasCfg.grid_size || (fieldConfig && fieldConfig.canvas && fieldConfig.canvas.grid_size) || 24, 10) || 24;
        var snapToGrid = !!canvasCfg.snap_to_grid;
        var defaultColor = String(canvasCfg.default_color || (fieldConfig && fieldConfig.canvas && fieldConfig.canvas.default_color) || '#fff59d');
        var initialState = canvasCfg.initial_state && typeof canvasCfg.initial_state === 'object' ? canvasCfg.initial_state : null;
        var allowedTools = Array.isArray(canvasCfg.tools)
            ? canvasCfg.tools.map(function (tool) { return String(tool || '').toLowerCase(); }).filter(Boolean)
            : [];
        var boardState = normalizeKonvaBoardState(currentValue, initialState);

        formState[key] = deepClone(boardState);

        var wrap = document.createElement('div');
        wrap.style.border = '1px solid #d4deea';
        wrap.style.borderRadius = '12px';
        wrap.style.background = '#f9fbff';
        wrap.style.overflow = 'hidden';

        var toolbar = document.createElement('div');
        toolbar.style.display = 'flex';
        toolbar.style.flexDirection = 'column';
        toolbar.style.gap = '12px';
        toolbar.style.padding = '8px';
        toolbar.style.borderBottom = '1px solid #dbe5f1';
        toolbar.style.background = '#fff';

        var createToolbarRow = function (titleText) {
            var row = document.createElement('div');
            row.style.display = 'flex';
            row.style.flexDirection = 'column';
            row.style.gap = '8px';

            var title = document.createElement('strong');
            title.className = 'kh-meta';
            title.style.color = '#475569';
            title.style.fontWeight = '700';
            title.textContent = titleText;
            row.appendChild(title);

            var buttons = document.createElement('div');
            buttons.style.display = 'flex';
            buttons.style.flexWrap = 'wrap';
            buttons.style.gap = '8px';
            row.appendChild(buttons);

            toolbar.appendChild(row);
            return buttons;
        };

        var buildToolbarButton = function (labelText, iconName) {
            var button = document.createElement('button');
            button.type = 'button';
            button.className = 'btn btn-secondary';
            button.style.display = 'inline-flex';
            button.style.alignItems = 'center';
            button.style.gap = '8px';

            var icon = document.createElement('span');
            icon.className = 'material-symbols-outlined';
            icon.setAttribute('aria-hidden', 'true');
            icon.style.fontSize = '20px';
            icon.textContent = iconName;
            button.appendChild(icon);

            var text = document.createElement('span');
            text.textContent = labelText;
            button.appendChild(text);

            return button;
        };

        var createButtons = createToolbarRow(t('canvasCreateTools', 'Create'));
        var viewButtons = createToolbarRow(t('canvasViewActions', 'View & Actions'));
        var hasTool = function (toolName) {
            if (!allowedTools.length) {
                return true;
            }
            return allowedTools.indexOf(String(toolName || '').toLowerCase()) !== -1;
        };

        var addNoteBtn = null;
        if (hasTool('sticky')) {
            addNoteBtn = buildToolbarButton(t('addStickyNote', 'Add sticky note'), 'sticky_note_2');
            createButtons.appendChild(addNoteBtn);
        }

        var addTextBtn = null;
        if (hasTool('text')) {
            addTextBtn = buildToolbarButton(t('addTextBox', 'Add text box'), 'text_fields');
            createButtons.appendChild(addTextBtn);
        }

        var addRectBtn = null;
        if (hasTool('shape') || hasTool('rect')) {
            addRectBtn = buildToolbarButton(t('addRectangle', 'Add rectangle'), 'rectangle');
            createButtons.appendChild(addRectBtn);
        }

        var addCircleBtn = null;
        if (hasTool('shape') || hasTool('circle')) {
            addCircleBtn = buildToolbarButton(t('addCircle', 'Add circle'), 'circle');
            createButtons.appendChild(addCircleBtn);
        }

        var addLineBtn = null;
        if (hasTool('line')) {
            addLineBtn = buildToolbarButton(t('addLine', 'Add line'), 'pen_size_2');
            createButtons.appendChild(addLineBtn);
        }

        var addArrowBtn = null;
        if (hasTool('arrow')) {
            addArrowBtn = buildToolbarButton(t('addArrow', 'Add arrow'), 'trending_flat');
            createButtons.appendChild(addArrowBtn);
        }

        var addImageBtn = null;
        if (hasTool('image')) {
            addImageBtn = buildToolbarButton(t('addImageUrl', 'Add image URL'), 'image');
            createButtons.appendChild(addImageBtn);
        }

        var deleteSelectionBtn = buildToolbarButton(t('deleteSelection', 'Delete selection'), 'delete');
        viewButtons.appendChild(deleteSelectionBtn);

        var zoomInBtn = buildToolbarButton(t('zoomIn', 'Zoom in'), 'zoom_in');
        viewButtons.appendChild(zoomInBtn);

        var zoomOutBtn = buildToolbarButton(t('zoomOut', 'Verkleinern'), 'zoom_out');
        viewButtons.appendChild(zoomOutBtn);

        var resetViewBtn = buildToolbarButton(t('resetCanvasView', 'Reset view'), 'center_focus_strong');
        viewButtons.appendChild(resetViewBtn);

        wrap.appendChild(toolbar);

        var scroll = document.createElement('div');
        scroll.style.overflow = 'auto';
        scroll.style.width = '100%';
        scroll.style.height = '60vh';
        scroll.style.minHeight = '520px';
        scroll.style.backgroundImage = 'linear-gradient(#eef3fa 1px, transparent 1px), linear-gradient(90deg, #eef3fa 1px, transparent 1px)';
        scroll.style.backgroundSize = gridSize + 'px ' + gridSize + 'px';
        scroll.style.backgroundColor = String(stageCfg.background || '#f9fbff');
        wrap.appendChild(scroll);

        var mount = document.createElement('div');
        var stageWidth = Math.max(1200, parseInt(stageCfg.width || 1800, 10) || 1800);
        var stageHeight = Math.max(900, parseInt(stageCfg.height || 1200, 10) || 1200);
        mount.style.width = stageWidth + 'px';
        mount.style.height = stageHeight + 'px';
        scroll.appendChild(mount);

        if (!(window.Konva && window.Konva.Stage && window.Konva.Layer)) {
            var fallback = document.createElement('textarea');
            fallback.rows = 10;
            fallback.value = JSON.stringify(boardState, null, 2);
            fallback.addEventListener('input', function () {
                var raw = String(fallback.value || '').trim();
                if (!raw) {
                    setFormStateValue(key, normalizeKonvaBoardState(null, initialState));
                    return;
                }
                try {
                    setFormStateValue(key, normalizeKonvaBoardState(JSON.parse(raw), initialState));
                } catch (e) {
                    setFormStateValue(key, raw);
                }
            });
            wrap.appendChild(fallback);
            return wrap;
        }

        var stage = new window.Konva.Stage({ container: mount, width: stageWidth, height: stageHeight, draggable: true });
        var gridLayer = new window.Konva.Layer({ listening: false });
        var edgeLayer = new window.Konva.Layer();
        var nodeLayer = new window.Konva.Layer();
        var transformer = new window.Konva.Transformer({
            rotateEnabled: false,
            enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right']
        });
        nodeLayer.add(transformer);
        stage.add(gridLayer);
        stage.add(edgeLayer);
        stage.add(nodeLayer);

        if (gridSize > 0) {
            for (var gx = 0; gx <= stageWidth; gx += gridSize) {
                gridLayer.add(new window.Konva.Line({ points: [gx, 0, gx, stageHeight], stroke: '#edf2fa', strokeWidth: 1 }));
            }
            for (var gy = 0; gy <= stageHeight; gy += gridSize) {
                gridLayer.add(new window.Konva.Line({ points: [0, gy, stageWidth, gy], stroke: '#edf2fa', strokeWidth: 1 }));
            }
            gridLayer.draw();
        }

        var nodes = boardState.nodes.slice();
        var edges = boardState.edges.slice();
        var getSelectedNodeId = function () {
            var selectedNodes = transformer.nodes();
            if (!selectedNodes || !selectedNodes.length) {
                return '';
            }
            return String(selectedNodes[0].id() || '');
        };
        var snap = function (value) {
            if (!snapToGrid || gridSize <= 0) return value;
            return Math.round(value / gridSize) * gridSize;
        };

        var applyZoom = function (nextScale) {
            var safeScale = Math.max(0.25, Math.min(3, parseFloat(nextScale || 1) || 1));
            stage.scale({ x: safeScale, y: safeScale });
            saveState(true);
            stage.batchDraw();
        };

        var saveState = function (markDirty) {
            var next = {
                viewport: { x: stage.x(), y: stage.y(), scale: stage.scaleX(), zoom: stage.scaleX() },
                nodes: nodes.map(function (node) {
                    return {
                        id: node.id,
                        kind: node.kind || 'sticky',
                        x: node.x,
                        y: node.y,
                        width: node.width,
                        height: node.height,
                        fill: node.fill,
                        stroke: node.stroke,
                        text: node.text,
                        fontSize: node.fontSize,
                        textFill: node.textFill,
                        imageUrl: node.imageUrl || ''
                    };
                }),
                edges: edges.map(function (edge) {
                    return { id: edge.id, kind: edge.kind || 'arrow', from: edge.from, to: edge.to, points: (edge.points || []).slice() };
                })
            };
            if (markDirty) setFormStateValue(key, next);
            else formState[key] = deepClone(next);
        };

        var renderScene = function () {
            edgeLayer.destroyChildren();
            nodeLayer.destroyChildren();
            nodeLayer.add(transformer);

            edges.forEach(function (edge) {
                if (!Array.isArray(edge.points) || edge.points.length < 4) return;
                var edgeShape = String(edge.kind || 'arrow') === 'line'
                    ? new window.Konva.Line({
                        points: edge.points,
                        stroke: '#334155',
                        strokeWidth: 2,
                        lineCap: 'round',
                        lineJoin: 'round'
                    })
                    : new window.Konva.Arrow({
                        points: edge.points,
                        pointerLength: 8,
                        pointerWidth: 8,
                        fill: '#334155',
                        stroke: '#334155',
                        strokeWidth: 2
                    });
                edgeLayer.add(edgeShape);
            });

            nodes.forEach(function (node) {
                var group = new window.Konva.Group({
                    id: node.id,
                    x: node.x,
                    y: node.y,
                    width: node.width,
                    height: node.height,
                    draggable: true
                });
                var isTextNode = String(node.kind || '') === 'text';
                var isCircleNode = String(node.kind || '') === 'circle';
                var isImageNode = String(node.kind || '') === 'image';
                var shape = null;
                if (!isTextNode && !isCircleNode && !isImageNode) {
                    shape = new window.Konva.Rect({
                        width: node.width,
                        height: node.height,
                        fill: node.fill,
                        stroke: node.stroke,
                        strokeWidth: 1,
                        cornerRadius: String(node.kind || '') === 'sticky' ? 10 : 4
                    });
                } else if (isCircleNode) {
                    shape = new window.Konva.Ellipse({
                        x: node.width / 2,
                        y: node.height / 2,
                        radiusX: node.width / 2,
                        radiusY: node.height / 2,
                        fill: node.fill,
                        stroke: node.stroke,
                        strokeWidth: 1
                    });
                } else if (isImageNode) {
                    shape = new window.Konva.Rect({
                        width: node.width,
                        height: node.height,
                        fill: '#f8fafc',
                        stroke: node.stroke || '#94a3b8',
                        strokeWidth: 1,
                        cornerRadius: 8
                    });
                    if (node.imageUrl) {
                        (function (groupRef, nodeRef) {
                            var imageObj = new window.Image();
                            imageObj.crossOrigin = 'Anonymous';
                            imageObj.onload = function () {
                                var imageNode = groupRef.findOne('.kh-konva-image-fill');
                                if (imageNode) {
                                    imageNode.image(imageObj);
                                    nodeLayer.batchDraw();
                                }
                            };
                            imageObj.src = nodeRef.imageUrl;
                        })(group, node);
                    }
                }
                var text = new window.Konva.Text({
                    x: isTextNode ? 0 : 10,
                    y: isTextNode ? 0 : 10,
                    width: Math.max(20, node.width - (isTextNode ? 0 : 20)),
                    height: Math.max(20, node.height - (isTextNode ? 0 : 20)),
                    text: node.text || '',
                    fontSize: node.fontSize || 15,
                    fill: node.textFill || '#111827',
                    lineHeight: 1.25
                });
                if (shape) {
                    group.add(shape);
                }
                if (isImageNode) {
                    var imageFill = new window.Konva.Image({
                        name: 'kh-konva-image-fill',
                        x: 0,
                        y: 0,
                        width: node.width,
                        height: node.height,
                        cornerRadius: 8
                    });
                    group.add(imageFill);
                    if (node.imageUrl) {
                        (function (imageNodeRef, nodeRef) {
                            var imageObj = new window.Image();
                            imageObj.crossOrigin = 'Anonymous';
                            imageObj.onload = function () {
                                imageNodeRef.image(imageObj);
                                nodeLayer.batchDraw();
                            };
                            imageObj.src = nodeRef.imageUrl;
                        })(imageFill, node);
                    }
                }
                if (!isImageNode || node.text) {
                    group.add(text);
                }
                nodeLayer.add(group);

                group.on('click tap', function () {
                    transformer.nodes([group]);
                    nodeLayer.batchDraw();
                });
                group.on('dblclick dbltap', function () {
                    var next = window.prompt(t('editNotePrompt', 'Edit note'), node.text || '');
                    if (next === null) return;
                    node.text = String(next);
                    saveState(true);
                    renderScene();
                });
                group.on('dragend', function () {
                    node.x = snap(group.x());
                    node.y = snap(group.y());
                    group.x(node.x);
                    group.y(node.y);
                    saveState(true);
                    renderScene();
                });
                group.on('transformend', function () {
                    node.width = Math.max(90, group.width() * group.scaleX());
                    node.height = Math.max(60, group.height() * group.scaleY());
                    node.x = snap(group.x());
                    node.y = snap(group.y());
                    group.scaleX(1);
                    group.scaleY(1);
                    saveState(true);
                    renderScene();
                });
            });
            edgeLayer.draw();
            nodeLayer.draw();
            saveState(false);
        };

        var pushNodeAndRefresh = function (nodeConfig) {
            nodes.push(nodeConfig);
            renderScene();
            setFormStateValue(key, deepClone(formState[key]));
        };

        if (addNoteBtn) {
            addNoteBtn.addEventListener('click', function () {
                pushNodeAndRefresh({
                    id: 'n-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'sticky',
                    x: snap(120 + nodes.length * 10),
                    y: snap(120 + nodes.length * 10),
                    width: 220,
                    height: 150,
                    text: t('newStickyNote', 'New note'),
                    fill: defaultColor,
                    stroke: '#d4bd57',
                    fontSize: 15,
                    textFill: '#111827'
                });
            });
        }

        if (addTextBtn) {
            addTextBtn.addEventListener('click', function () {
                pushNodeAndRefresh({
                    id: 'n-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'text',
                    x: snap(140 + nodes.length * 10),
                    y: snap(140 + nodes.length * 10),
                    width: 280,
                    height: 110,
                    text: t('newTextBox', 'New text box'),
                    fill: '#111827',
                    stroke: 'transparent',
                    fontSize: 16,
                    textFill: '#111827'
                });
            });
        }

        if (addRectBtn) {
            addRectBtn.addEventListener('click', function () {
                pushNodeAndRefresh({
                    id: 'n-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'rect',
                    x: snap(160 + nodes.length * 10),
                    y: snap(160 + nodes.length * 10),
                    width: 240,
                    height: 160,
                    text: '',
                    fill: '#dbeafe',
                    stroke: '#60a5fa',
                    fontSize: 15,
                    textFill: '#111827'
                });
            });
        }

        if (addCircleBtn) {
            addCircleBtn.addEventListener('click', function () {
                pushNodeAndRefresh({
                    id: 'n-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'circle',
                    x: snap(180 + nodes.length * 10),
                    y: snap(180 + nodes.length * 10),
                    width: 180,
                    height: 180,
                    text: '',
                    fill: '#e0f2fe',
                    stroke: '#38bdf8',
                    fontSize: 15,
                    textFill: '#111827'
                });
            });
        }

        if (addLineBtn) {
            addLineBtn.addEventListener('click', function () {
                edges.push({
                    id: 'e-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'line',
                    from: '',
                    to: '',
                    points: [snap(140), snap(140 + edges.length * 20), snap(340), snap(140 + edges.length * 20)]
                });
                renderScene();
                setFormStateValue(key, deepClone(formState[key]));
            });
        }

        if (addArrowBtn) {
            addArrowBtn.addEventListener('click', function () {
                edges.push({
                    id: 'e-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'arrow',
                    from: '',
                    to: '',
                    points: [snap(140), snap(200 + edges.length * 20), snap(340), snap(200 + edges.length * 20)]
                });
                renderScene();
                setFormStateValue(key, deepClone(formState[key]));
            });
        }

        if (addImageBtn) {
            addImageBtn.addEventListener('click', function () {
                var imageUrl = window.prompt(t('enterImageUrl', 'Enter image URL'), 'https://');
                if (!imageUrl) {
                    return;
                }
                pushNodeAndRefresh({
                    id: 'n-' + Date.now() + '-' + Math.floor(Math.random() * 1000),
                    kind: 'image',
                    x: snap(200 + nodes.length * 10),
                    y: snap(200 + nodes.length * 10),
                    width: 260,
                    height: 180,
                    text: '',
                    fill: '#f8fafc',
                    stroke: '#94a3b8',
                    fontSize: 15,
                    textFill: '#111827',
                    imageUrl: String(imageUrl)
                });
            });
        }

        deleteSelectionBtn.addEventListener('click', function () {
            var selectedId = getSelectedNodeId();
            if (!selectedId) {
                return;
            }
            nodes = nodes.filter(function (node) {
                return String(node.id || '') !== selectedId;
            });
            edges = edges.filter(function (edge) {
                return String(edge.from || '') !== selectedId && String(edge.to || '') !== selectedId;
            });
            transformer.nodes([]);
            renderScene();
            setFormStateValue(key, deepClone(formState[key]));
        });

        zoomInBtn.addEventListener('click', function () {
            applyZoom(stage.scaleX() * 1.1);
        });

        zoomOutBtn.addEventListener('click', function () {
            applyZoom(stage.scaleX() / 1.1);
        });

        resetViewBtn.addEventListener('click', function () {
            stage.position({ x: 0, y: 0 });
            applyZoom(1);
        });

        stage.on('wheel', function (event) {
            if (!(event.evt.ctrlKey || event.evt.metaKey)) return;
            event.evt.preventDefault();
            var oldScale = stage.scaleX();
            var pointer = stage.getPointerPosition();
            if (!pointer) return;
            var scaleBy = 1.05;
            var direction = event.evt.deltaY > 0 ? -1 : 1;
            var nextScale = direction > 0 ? oldScale * scaleBy : oldScale / scaleBy;
            nextScale = Math.max(0.25, Math.min(3, nextScale));
            var mousePointTo = {
                x: (pointer.x - stage.x()) / oldScale,
                y: (pointer.y - stage.y()) / oldScale
            };
            stage.scale({ x: nextScale, y: nextScale });
            stage.position({
                x: pointer.x - mousePointTo.x * nextScale,
                y: pointer.y - mousePointTo.y * nextScale
            });
            saveState(true);
            stage.batchDraw();
        });

        stage.x(boardState.viewport.x || 0);
        stage.y(boardState.viewport.y || 0);
        stage.scale({ x: boardState.viewport.scale || 1, y: boardState.viewport.scale || 1 });
        renderScene();

        syncTemplateBeforeSave = function () {
            saveState(false);
        };

        return wrap;
    };

    var renderTemplateSections = function (schema, payload) {
        if (!templateSectionsEl) {
            return;
        }
        templateSectionsEl.innerHTML = '';
        syncTemplateBeforeSave = null;
        clearFieldErrors();
        formState = createFormStateFromSchema(schema, payload);
        var renderMode = resolveTemplateRenderMode(schema);

        var sections = extractTemplateSectionsFromSchema(schema);
        if (!sections.length) {
            var fallback = document.createElement('p');
            fallback.className = 'kh-meta';
            fallback.textContent = t('noTemplateSchema', 'No template schema available. Generic editor is active.');
            templateSectionsEl.appendChild(fallback);
            return;
        }

        sections.forEach(function (section) {
            var sectionWrap = document.createElement('div');
            sectionWrap.className = 'kh-template-section';

            if (section.label) {
                var sectionTitle = document.createElement('h5');
                sectionTitle.textContent = section.label;
                sectionWrap.appendChild(sectionTitle);
            }

            section.fields.forEach(function (fieldConfig) {
                var key = String(fieldConfig.key || '').trim();
                if (!key) {
                    return;
                }
                var label = String(fieldConfig.label || key);
                var fieldKind = normalizeFieldKind(fieldConfig.field, fieldConfig);
                var currentValue = Object.prototype.hasOwnProperty.call(formState, key) ? formState[key] : null;
                var options = (Array.isArray(fieldConfig.options) ? fieldConfig.options : []).map(normalizeOption);

                var wrapper = document.createElement('div');
                var labelEl = document.createElement('label');
                labelEl.textContent = label;
                wrapper.appendChild(labelEl);

                var input;
                if (fieldKind === 'boolean') {
                    input = document.createElement('input');
                    input.type = 'checkbox';
                    input.checked = currentValue === true || String(currentValue).toLowerCase() === 'true' || String(currentValue) === '1';
                    input.addEventListener('change', function () {
                        setFormStateValue(key, !!input.checked);
                    });
                } else if (fieldKind === 'text') {
                    input = document.createElement('input');
                    input.type = 'text';
                    input.value = currentValue == null ? '' : String(currentValue);
                    input.addEventListener('input', function () {
                        setFormStateValue(key, String(input.value || ''));
                    });
                } else if (fieldKind === 'number') {
                    input = document.createElement('input');
                    input.type = 'number';
                    input.value = currentValue == null || currentValue === '' ? '' : String(currentValue);
                    input.addEventListener('input', function () {
                        var rawNumber = String(input.value || '').trim();
                        setFormStateValue(key, rawNumber === '' ? '' : Number(rawNumber));
                    });
                } else if (fieldKind === 'select') {
                    input = document.createElement('select');
                    var emptyOption = document.createElement('option');
                    emptyOption.value = '';
                    emptyOption.textContent = t('pleaseSelect', 'Please select');
                    input.appendChild(emptyOption);
                    options.forEach(function (optionRaw) {
                        var option = document.createElement('option');
                        option.value = optionRaw.value;
                        option.textContent = optionRaw.label;
                        if (currentValue != null && option.value === String(currentValue)) {
                            option.selected = true;
                        }
                        input.appendChild(option);
                    });
                    input.addEventListener('change', function () {
                        setFormStateValue(key, String(input.value || ''));
                    });
                } else if (fieldKind === 'radio') {
                    input = document.createElement('div');
                    input.className = 'kh-radio-group';
                    options.forEach(function (optionRaw, index) {
                        var optionWrap = document.createElement('label');
                        optionWrap.style.display = 'block';
                        var optionInput = document.createElement('input');
                        optionInput.type = 'radio';
                        optionInput.name = 'kh-template-radio-' + key;
                        optionInput.value = optionRaw.value;
                        optionInput.checked = String(currentValue || '') === optionRaw.value;
                        optionInput.id = 'kh-template-radio-' + key + '-' + index;
                        optionInput.addEventListener('change', function () {
                            if (optionInput.checked) {
                                setFormStateValue(key, optionRaw.value);
                            }
                        });
                        optionWrap.appendChild(optionInput);
                        optionWrap.appendChild(document.createTextNode(' ' + optionRaw.label));
                        input.appendChild(optionWrap);
                    });
                } else if (fieldKind === 'checkbox_group') {
                    input = document.createElement('div');
                    input.className = 'kh-checkbox-group';
                    var selectedValues = Array.isArray(currentValue) ? currentValue.map(function (v) { return String(v); }) : [];
                    options.forEach(function (optionRaw, index) {
                        var optionWrap = document.createElement('label');
                        optionWrap.style.display = 'block';
                        var optionInput = document.createElement('input');
                        optionInput.type = 'checkbox';
                        optionInput.value = optionRaw.value;
                        optionInput.id = 'kh-template-checkbox-' + key + '-' + index;
                        optionInput.checked = selectedValues.indexOf(optionRaw.value) !== -1;
                        optionInput.addEventListener('change', function () {
                            var values = [];
                            var checks = input.querySelectorAll('input[type="checkbox"]');
                            checks.forEach(function (check) {
                                if (check.checked) {
                                    values.push(String(check.value || ''));
                                }
                            });
                            setFormStateValue(key, values);
                        });
                        optionWrap.appendChild(optionInput);
                        optionWrap.appendChild(document.createTextNode(' ' + optionRaw.label));
                        input.appendChild(optionWrap);
                    });
                } else if (fieldKind === 'multi_choice') {
                    input = document.createElement('select');
                    input.multiple = true;
                    var selectedValuesMulti = Array.isArray(currentValue) ? currentValue.map(function (v) { return String(v); }) : [];
                    options.forEach(function (optionRaw) {
                        var option = document.createElement('option');
                        option.value = optionRaw.value;
                        option.textContent = optionRaw.label;
                        if (selectedValuesMulti.indexOf(option.value) !== -1) {
                            option.selected = true;
                        }
                        input.appendChild(option);
                    });
                    input.addEventListener('change', function () {
                        var selected = [];
                        Array.prototype.slice.call(input.options || []).forEach(function (option) {
                            if (option.selected && option.value !== '') {
                                selected.push(option.value);
                            }
                        });
                        setFormStateValue(key, selected);
                    });
                } else if (fieldKind === 'image' || fieldKind === 'file') {
                    input = document.createElement('div');

                    var currentRef = currentValue && typeof currentValue === 'object' ? currentValue : null;
                    var currentRefLabel = document.createElement('small');
                    currentRefLabel.className = 'kh-meta';
                    currentRefLabel.setAttribute('data-template-file-meta', key);
                    currentRefLabel.textContent = currentRef && (currentRef.name || currentRef.url)
                        ? (t('fileAttached', 'Attached:') + ' ' + String(currentRef.name || currentRef.url))
                        : t('noFileAttached', 'No file attached yet.');
                    input.appendChild(currentRefLabel);

                    var fileInput = document.createElement('input');
                    fileInput.type = 'file';
                    if (fieldConfig.accept) {
                        fileInput.setAttribute('accept', String(fieldConfig.accept));
                    } else if (fieldKind === 'image') {
                        fileInput.setAttribute('accept', 'image/*');
                    }
                    fileInput.addEventListener('change', function () {
                        var selectedFile = fileInput.files && fileInput.files[0] ? fileInput.files[0] : null;
                        if (!selectedFile) {
                            return;
                        }
                        if (!currentResult || !currentResult.id) {
                            notify('warning', t('saveResultBeforeUpload', 'Please save the result once before uploading files.'));
                            fileInput.value = '';
                            return;
                        }
                        pendingUploads += 1;
                        updateSaveButtonsState();
                        api.uploadResultFiles(currentResult.id, [selectedFile])
                            .then(function (uploadPayload) {
                                var fileRef = buildUploadedFileReference(uploadPayload, selectedFile);
                                setFormStateValue(key, fileRef);
                                currentRefLabel.textContent = fileRef.name
                                    ? (t('fileAttached', 'Attached:') + ' ' + fileRef.name)
                                    : t('fileAttached', 'Attached:');
                                return refreshResultEditor(currentResult.id, false);
                            })
                            .then(function () {
                                notify('success', t('fileUploadSuccess', 'File uploaded and attached.'));
                            })
                            .catch(function (error) {
                                handleApiError(error, t('fileUploadFailed', 'File upload failed.'));
                            })
                            .finally(function () {
                                pendingUploads = Math.max(0, pendingUploads - 1);
                                updateSaveButtonsState();
                                fileInput.value = '';
                            });
                    });
                    input.appendChild(fileInput);
                } else if (fieldKind === 'canvas_freeform') {
                    if (renderMode === 'konva') {
                        input = createKonvaBoardEditor(key, schema, fieldConfig, currentValue);
                    } else {
                        input = document.createElement('textarea');
                        input.rows = 8;
                        input.value = currentValue == null
                            ? JSON.stringify({ widgets: [], links: [] }, null, 2)
                            : (typeof currentValue === 'string' ? currentValue : JSON.stringify(currentValue, null, 2));
                        input.addEventListener('input', function () {
                            var raw = String(input.value || '').trim();
                            if (!raw) {
                                setFormStateValue(key, { widgets: [], links: [] });
                                return;
                            }
                            try {
                                setFormStateValue(key, JSON.parse(raw));
                            } catch (e) {
                                setFormStateValue(key, raw);
                            }
                        });
                    }
                } else {
                    input = document.createElement('textarea');
                    input.rows = fieldKind === 'json' ? 6 : 3;
                    input.value = fieldKind === 'json'
                        ? (currentValue == null ? '' : (typeof currentValue === 'string' ? currentValue : JSON.stringify(currentValue, null, 2)))
                        : (currentValue == null ? '' : String(currentValue));
                    input.addEventListener('input', function () {
                        if (fieldKind === 'json') {
                            var rawJson = String(input.value || '').trim();
                            if (rawJson === '') {
                                setFormStateValue(key, '');
                                return;
                            }
                            try {
                                setFormStateValue(key, JSON.parse(rawJson));
                            } catch (e) {
                                setFormStateValue(key, rawJson);
                            }
                            return;
                        }
                        setFormStateValue(key, String(input.value || ''));
                    });
                }

                if (
                    fieldConfig.placeholder
                    && input
                    && (input.tagName === 'INPUT' || input.tagName === 'TEXTAREA')
                ) {
                    input.setAttribute('placeholder', fieldConfig.placeholder);
                }
                if (input && fieldKind !== 'radio' && fieldKind !== 'checkbox_group' && fieldKind !== 'file' && fieldKind !== 'image') {
                    input.setAttribute('data-template-key', key);
                    input.setAttribute('data-template-kind', fieldKind);
                }
                wrapper.appendChild(input);

                if (fieldConfig.help) {
                    var help = document.createElement('small');
                    help.className = 'kh-meta';
                    help.textContent = fieldConfig.help;
                    wrapper.appendChild(help);
                }

                var fieldError = document.createElement('small');
                fieldError.className = 'kh-meta';
                fieldError.style.color = '#b91c1c';
                fieldError.style.display = 'none';
                fieldError.setAttribute('data-template-error-key', key);
                wrapper.appendChild(fieldError);

                sectionWrap.appendChild(wrapper);
            });

            templateSectionsEl.appendChild(sectionWrap);
        });
        updateSaveButtonsState();
    };

    var collectTemplatePayload = function () {
        return deepClone(formState) || {};
    };

    var hasMeaningfulValue = function (value) {
        if (value == null) return false;
        if (typeof value === 'boolean') return value === true;
        if (typeof value === 'number') return !Number.isNaN(value);
        if (typeof value === 'string') return value.trim() !== '';
        if (Array.isArray(value)) {
            if (!value.length) return false;
            for (var i = 0; i < value.length; i += 1) {
                if (hasMeaningfulValue(value[i])) return true;
            }
            return false;
        }
        if (typeof value === 'object') {
            var keys = Object.keys(value);
            if (!keys.length) return false;
            for (var j = 0; j < keys.length; j += 1) {
                if (hasMeaningfulValue(value[keys[j]])) return true;
            }
            return false;
        }
        return false;
    };

    var hasMeaningfulResult = function (resultTitle, resultText, payload) {
        if (String(resultTitle || '').trim() !== '') return true;
        if (String(resultText || '').trim() !== '') return true;
        return hasMeaningfulValue(payload);
    };

    var normalizeResultStatus = function (value) {
        var status = String(value || '').toLowerCase();
        if (status === 'in_progress') return 'in_progress';
        if (status === 'completed') return 'completed';
        return 'draft';
    };

    var normalizeResultStatusLabel = function (value) {
        var status = normalizeResultStatus(value);
        if (status === 'in_progress') {
            return t('resultStatusInProgress', 'In progress');
        }
        if (status === 'completed') {
            return t('resultStatusCompleted', 'Completed');
        }
        return t('resultStatusDraft', 'Draft');
    };

    var getMemberDisplayName = function (member) {
        if (!member || typeof member !== 'object') {
            return '';
        }
        return String(
            member.name
            || member.display_name
            || member.email
            || (member.user && (member.user.name || member.user.display_name || member.user.email))
            || ''
        ).trim();
    };

    var getMethodRecordId = function (methodItem) {
        return parseInt(methodItem && (methodItem.record_id || methodItem.item_id || methodItem.method_id) || 0, 10) || 0;
    };

    var removeMethodFromLocalState = function (removeId) {
        var rid = parseInt(removeId || 0, 10) || 0;
        if (rid <= 0) {
            return;
        }
        methodsCache = (Array.isArray(methodsCache) ? methodsCache : []).filter(function (methodItem) {
            var recordId = getMethodRecordId(methodItem);
            var itemId = parseInt(methodItem && methodItem.item_id || 0, 10) || 0;
            var contentMethodId = parseInt(methodItem && methodItem.content_method_id || 0, 10) || 0;
            return recordId !== rid && itemId !== rid && contentMethodId !== rid;
        });
        renderMethodList(methodsCache);
        if (statsMethodsEl) {
            statsMethodsEl.textContent = String(methodsCache.length || 0);
        }
    };

    var syncMethodsAfterRemoval = function () {
        window.setTimeout(function () {
            Promise.all([loadMethods(), loadDashboardData()])
                .catch(function () {
                    window.location.reload();
                });
        }, 1200);
    };

    var getResultDescriptionHtml = function () {
        return resultDescriptionEl ? String(resultDescriptionEl.innerHTML || '').trim() : '';
    };

    var getResultDescriptionText = function () {
        if (!resultDescriptionEl) {
            return '';
        }
        return String(resultDescriptionEl.textContent || '').trim();
    };

    var syncResultDescriptionPlaceholder = function () {
        if (!resultDescriptionEl) {
            return;
        }
        var plainText = String(resultDescriptionEl.textContent || '')
            .replace(/\u00a0/g, ' ')
            .trim();
        resultDescriptionEl.classList.toggle('is-empty', plainText === '');
    };

    var populateAssignedUserOptions = function (selectedUserId) {
        if (!resultAssignedUserEl) {
            return;
        }
        var activeValue = parseInt(selectedUserId || 0, 10) || 0;
        resultAssignedUserEl.innerHTML = '';
        var emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = t('nobodyAssigned', 'Nobody assigned');
        resultAssignedUserEl.appendChild(emptyOption);

        membersCache.forEach(function (member) {
            var status = String(member.status || '').toLowerCase();
            if (status && status !== 'active') {
                return;
            }
            var userId = parseInt(member.user_id || member.id || (member.user && member.user.id) || 0, 10) || 0;
            if (userId <= 0) {
                return;
            }
            var option = document.createElement('option');
            option.value = String(userId);
            option.textContent = getMemberDisplayName(member) || ('User #' + userId);
            if (userId === activeValue) {
                option.selected = true;
            }
            resultAssignedUserEl.appendChild(option);
        });
    };

    var populateResultMethodOptions = function (selectedIds) {
        if (!resultMethodsEl) {
            return;
        }
        var selectedMap = {};
        (Array.isArray(selectedIds) ? selectedIds : []).forEach(function (id) {
            selectedMap[String(parseInt(id || 0, 10) || 0)] = true;
        });
        resultMethodsEl.innerHTML = '';
        methodsCache.forEach(function (methodItem) {
            var option = document.createElement('option');
            var optionId = getMethodRecordId(methodItem);
            option.value = String(optionId);
            option.textContent = methodItem.title || ('Method #' + optionId);
            option.selected = !!selectedMap[String(optionId)];
            resultMethodsEl.appendChild(option);
        });
    };

    var renderResultImagePreview = function (resultItem) {
        if (!resultImagePreviewEl || !resultImageSelectEl) {
            return;
        }
        resultImagePreviewEl.innerHTML = '';
        var selectedId = parseInt(resultImageSelectEl.value || 0, 10) || 0;
        var files = resultItem && Array.isArray(resultItem.files) ? resultItem.files : [];
        var selectedFile = files.find(function (fileItem) {
            return (parseInt(fileItem.id || 0, 10) || 0) === selectedId;
        }) || (resultItem && resultItem.image ? resultItem.image : null);
        if (!selectedFile || !selectedFile.url) {
            return;
        }
        var preview = document.createElement('img');
        preview.src = selectedFile.url;
        preview.alt = selectedFile.name || t('openImage', 'Open image');
        resultImagePreviewEl.appendChild(preview);
    };

    var renderResultImageOptions = function (resultItem) {
        if (!resultImageSelectEl) {
            return;
        }
        resultImageSelectEl.innerHTML = '';
        var emptyOption = document.createElement('option');
        emptyOption.value = '';
        emptyOption.textContent = t('noPreviewImage', 'No preview image');
        resultImageSelectEl.appendChild(emptyOption);
        var selectedId = parseInt(resultItem && resultItem.image_file_id || 0, 10) || 0;
        (resultItem && Array.isArray(resultItem.files) ? resultItem.files : []).forEach(function (fileItem) {
            if (resolveFileTypeGroup(fileItem) !== 'image') {
                return;
            }
            var option = document.createElement('option');
            option.value = String(fileItem.id || '');
            option.textContent = fileItem.name || ('Image #' + fileItem.id);
            if ((parseInt(fileItem.id || 0, 10) || 0) === selectedId) {
                option.selected = true;
            }
            resultImageSelectEl.appendChild(option);
        });
        renderResultImagePreview(resultItem);
    };

    var renderResultFiles = function (resultItem) {
        if (!resultFilesListEl) {
            return;
        }
        resultFilesListEl.innerHTML = '';
        var files = resultItem && Array.isArray(resultItem.files) ? resultItem.files : [];
        if (!files.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noResultFilesYet', 'No files attached yet.');
            resultFilesListEl.appendChild(empty);
            renderResultImageOptions(resultItem);
            return;
        }
        files.forEach(function (fileItem) {
            var row = document.createElement('div');
            row.className = 'kh-result-file-row';

            var textWrap = document.createElement('div');
            var nameEl = document.createElement('strong');
            nameEl.textContent = fileItem.name;
            textWrap.appendChild(nameEl);

            var meta = document.createElement('p');
            meta.className = 'kh-meta';
            meta.textContent = [formatFileSize(fileItem.size), fileItem.mime].filter(function (part) { return !!part; }).join(' · ');
            textWrap.appendChild(meta);
            row.appendChild(textWrap);

            var actions = document.createElement('div');
            actions.className = 'kh-actions';

            if (fileItem.url) {
                var openLink = document.createElement('a');
                openLink.className = 'btn btn-secondary';
                openLink.href = fileItem.url;
                openLink.target = '_blank';
                openLink.rel = 'noopener noreferrer';
                openLink.textContent = t('openFile', 'Open file');
                actions.appendChild(openLink);
            }

            if (currentResult && currentResult.id && fileItem.id > 0) {
                var removeBtn = document.createElement('button');
                removeBtn.type = 'button';
                removeBtn.className = 'btn btn-delete';
                removeBtn.textContent = t('deleteFileLabel', 'Delete file');
                removeBtn.addEventListener('click', function () {
                    if (!window.confirm(t('confirmDeleteFile', 'Delete file?'))) {
                        return;
                    }
                    api.removeResultFile(currentResult.id, fileItem.id)
                        .then(function (payload) {
                            notify('success', buildFlashMessage(payload, t('projectFileDeleted', 'File deleted.')));
                            return refreshResultEditor(currentResult.id, false);
                        })
                        .catch(function (error) {
                            handleApiError(error, t('projectFileDeleteFailed', 'File could not be deleted.'));
                        });
                });
                actions.appendChild(removeBtn);
            }

            row.appendChild(actions);
            resultFilesListEl.appendChild(row);
        });
        renderResultImageOptions(resultItem);
    };

    var getDefaultResultTemplate = function (selectedMethodIds) {
        var ids = Array.isArray(selectedMethodIds) ? selectedMethodIds : [];
        for (var i = 0; i < ids.length; i += 1) {
            var wantedId = parseInt(ids[i] || 0, 10) || 0;
            var match = methodsCache.find(function (methodItem) {
                return getMethodRecordId(methodItem) === wantedId || (parseInt(methodItem.item_id || 0, 10) || 0) === wantedId;
            });
            if (!match) {
                continue;
            }
            var schema = match.template_schema;
            if ((!schema || typeof schema !== 'object') && Array.isArray(match.template_fields) && match.template_fields.length) {
                schema = { fields: match.template_fields };
            }
            return {
                template_type: String(match.template_type || '').trim().toLowerCase(),
                template_version: String(match.template_version || '1.0').trim(),
                template_schema: schema || null
            };
        }
        return {
            template_type: '',
            template_version: '1.0',
            template_schema: null
        };
    };

    var getSelectedResultMethodIds = function () {
        return resultMethodsEl
            ? Array.prototype.slice.call(resultMethodsEl.options || []).filter(function (option) {
                return !!option.selected;
            }).map(function (option) {
                return parseInt(option.value || 0, 10) || 0;
            }).filter(function (id) { return id > 0; })
            : [];
    };

    var ensureTemplateForSelectedMethods = function (selectedMethodIds) {
        var ids = Array.isArray(selectedMethodIds) ? selectedMethodIds : [];
        var templateDefinition = getDefaultResultTemplate(ids);
        if (templateDefinition.template_schema) {
            return Promise.resolve(templateDefinition);
        }

        var selectedOptionIds = ids.slice();
        if (!selectedOptionIds.length) {
            return Promise.resolve(templateDefinition);
        }

        var fetchQueue = selectedOptionIds.map(function (selectedId) {
            var methodMatch = methodsCache.find(function (methodItem) {
                return getMethodRecordId(methodItem) === selectedId || (parseInt(methodItem.item_id || 0, 10) || 0) === selectedId;
            });
            if (!methodMatch || !methodMatch.item_id) {
                return Promise.resolve(null);
            }
            return api.getMethod(methodMatch.item_id)
                .then(function (payload) {
                    var rows = extractRows(payload);
                    var row = rows.length ? rows[0] : extractSingle(payload);
                    var normalized = normalizeMethodItem(row);
                    if (!normalized) {
                        return null;
                    }
                    var existingIndex = methodsCache.findIndex(function (entry) {
                        return getMethodRecordId(entry) === getMethodRecordId(normalized) || entry.item_id === normalized.item_id;
                    });
                    if (existingIndex !== -1) {
                        methodsCache[existingIndex] = normalized;
                    } else {
                        methodsCache.push(normalized);
                    }
                    return normalized;
                })
                .catch(function () {
                    return null;
                });
        });

        return Promise.all(fetchQueue).then(function () {
            return getDefaultResultTemplate(ids);
        });
    };

    var fillEditorFromResult = function (item) {
        if (!item || !editorEl) {
            return;
        }
        currentResult = item;
        currentMethod = null;
        editorDirty = false;
        setEditorReadOnly(false);
        setEditorError('');
        clearFieldErrors();
        openModal(resultModal);
        if (editorTitleEl) editorTitleEl.textContent = item.title || (t('resultLabel', 'Result') + ' #' + item.id);
        if (editorStatusLineEl) {
            var statusLineParts = [];
            if (item.updated_at) {
                statusLineParts.push(t('lastEdited', 'Last edited:') + ' ' + formatResultDate(item.updated_at));
            }
            if (item.updated_by && item.updated_by.name) {
                statusLineParts.push(t('byLabel', 'by') + ' ' + item.updated_by.name);
            }
            editorStatusLineEl.textContent = statusLineParts.join(' · ') || t('noResultSaved', 'No result saved yet.');
        }
        if (resultStatusEl) resultStatusEl.value = normalizeResultStatus(item.status || 'draft');
        if (resultTitleEl) resultTitleEl.value = item.title || '';
        if (resultShortDescriptionEl) resultShortDescriptionEl.value = item.short_description || '';
        if (resultDescriptionEl) {
            resultDescriptionEl.innerHTML = item.description || '';
            syncResultDescriptionPlaceholder();
        }
        if (resultDeleteBtn) resultDeleteBtn.style.display = item.id ? 'inline-flex' : 'none';
        populateAssignedUserOptions(item.assigned_user_id);
        populateResultMethodOptions(item.project_method_ids || []);
        updateEditorStatusChip(item.status || 'draft');
        renderResultFiles(item);

        var schema = item.template_schema;
        if (!schema || typeof schema !== 'object') {
            var fallbackTemplate = getDefaultResultTemplate(item.project_method_ids || []);
            schema = fallbackTemplate.template_schema;
            if (!item.template_type) {
                item.template_type = fallbackTemplate.template_type;
            }
        }
        renderTemplateSections(schema, item.payload || {});
        updateSaveButtonsState();
    };

    var closeEditor = function (askConfirm) {
        if (!editorEl) {
            return true;
        }
        if (askConfirm && editorDirty) {
            if (!window.confirm(t('unsavedChangesConfirm', 'Unsaved changes will be lost. Continue?'))) {
                return false;
            }
        }
        closeModal(resultModal);
        currentMethod = null;
        currentResult = null;
        editorDirty = false;
        setEditorError('');
        return true;
    };

    var refreshResultEditor = function (resultId, showNotifications) {
        var rid = parseInt(resultId || 0, 10) || 0;
        if (rid <= 0) {
            return Promise.resolve();
        }
        return api.getResult(rid)
            .then(function (payload) {
                var source = extractSingle(payload);
                var normalized = normalizeProjectResult(source);
                if (!normalized) {
                    throw new Error('Invalid result payload');
                }
                resultsCache = resultsCache.map(function (entry) {
                    return entry.id === normalized.id ? normalized : entry;
                });
                fillEditorFromResult(normalized);
                renderProjectResults(resultsCache);
                if (showNotifications) {
                    notify('success', t('resultSavedSuccess', 'Result saved successfully.'));
                }
            });
    };

    var createEmptyResult = function () {
        return {
            id: 0,
            title: '',
            short_description: '',
            description: '',
            image: null,
            image_file_id: null,
            status: 'draft',
            assigned_user_id: null,
            assigned_user: null,
            methods: [],
            project_method_ids: [],
            template_type: '',
            template_version: '1.0',
            template_schema: null,
            payload: {},
            files: [],
            files_count: 0,
            updated_by: null,
            updated_at: null,
            created_by: null,
            created_at: null
        };
    };

    var openNewResultEditor = function () {
        if (!hasAssignedProjectMethods()) {
            notify('warning', t('resultNeedsProjectMethods', 'You can only create results once this project has at least one method.'));
            return;
        }
        if (!closeEditor(true)) {
            return;
        }
        fillEditorFromResult(createEmptyResult());
    };

    var openResultEditor = function (resultId) {
        var rid = parseInt(resultId || 0, 10) || 0;
        if (rid <= 0) {
            openNewResultEditor();
            return;
        }
        if (currentResult && currentResult.id !== rid && editorDirty) {
            if (!window.confirm(t('unsavedChangesConfirm', 'Unsaved changes will be lost. Continue?'))) {
                return;
            }
        }
        setEditorError('');
        api.getResult(rid)
            .then(function (payload) {
                var normalized = normalizeProjectResult(extractSingle(payload));
                if (!normalized) {
                    throw new Error('Invalid result payload');
                }
                fillEditorFromResult(normalized);
            })
            .catch(function (error) {
                handleApiError(error, t('couldNotLoadResult', 'Could not load result.'));
            });
    };

    var renderProjectResults = function (results) {
        if (!resultsListEl) {
            return;
        }
        resultsListEl.innerHTML = '';
        var rows = Array.isArray(results) ? results.slice() : [];
        if (!rows.length) {
            if (!hasAssignedProjectMethods()) {
                return;
            }
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noResultsYet', 'No results saved yet.');
            resultsListEl.appendChild(empty);
            return;
        }

        var statusFilter = String(resultsStatusFilterEl && resultsStatusFilterEl.value ? resultsStatusFilterEl.value : 'all').toLowerCase();
        if (statusFilter === 'draft' || statusFilter === 'in_progress' || statusFilter === 'completed') {
            rows = rows.filter(function (entry) {
                return String(entry && entry.status || '').toLowerCase() === statusFilter;
            });
        }
        if (!rows.length) {
            var emptyByFilter = document.createElement('p');
            emptyByFilter.className = 'kh-meta';
            emptyByFilter.textContent = t('noResultsForFilter', 'No results found for this filter.');
            resultsListEl.appendChild(emptyByFilter);
            return;
        }

        rows.sort(function (a, b) {
            var aTime = Date.parse(String(a && (a.updated_at || a.created_at) || '')) || 0;
            var bTime = Date.parse(String(b && (b.updated_at || b.created_at) || '')) || 0;
            return bTime - aTime;
        });

        rows.forEach(function (entry) {
            var card = document.createElement('div');
            card.className = 'ih-method-item kh-result-card kh-method-card-minimal';

            var previewFile = resolveResultPreviewImage(entry);
            if (previewFile && previewFile.url) {
                var preview = document.createElement('img');
                preview.className = 'kh-result-card-image kh-method-card-minimal-image';
                preview.src = previewFile.url;
                preview.alt = previewFile.name || entry.title || t('resultLabel', 'Result');
                card.appendChild(preview);
            }

            var body = document.createElement('div');
            body.className = 'kh-result-card-body kh-method-card-minimal-body';

            var head = document.createElement('div');
            head.className = 'kh-result-card-head';

            var titleWrap = document.createElement('div');
            var title = document.createElement('p');
            var strong = document.createElement('strong');
            strong.textContent = String(entry.title || (t('resultLabel', 'Result') + ' #' + entry.id));
            title.appendChild(strong);
            titleWrap.appendChild(title);

            if (entry.short_description) {
                var shortDescription = document.createElement('p');
                shortDescription.className = 'kh-meta';
                shortDescription.textContent = entry.short_description;
                titleWrap.appendChild(shortDescription);
            }
            head.appendChild(titleWrap);

            var badge = document.createElement('span');
            badge.className = 't-tag ih-badge';
            badge.textContent = normalizeResultStatusLabel(entry.status);
            head.appendChild(badge);
            body.appendChild(head);

            var metaList = document.createElement('div');
            metaList.className = 'kh-result-card-meta';
            var metaItems = [];
            if (entry.methods.length) {
                metaItems.push(t('linkedMethodsLabel', 'Methods') + ': ' + entry.methods.map(function (methodEntry) {
                    return methodEntry.title || ('#' + (methodEntry.record_id || methodEntry.method_id));
                }).join(', '));
            }
            if (entry.assigned_user && entry.assigned_user.name) {
                metaItems.push(t('assignedToLabel', 'Assigned to') + ': ' + entry.assigned_user.name);
            }
            if (entry.updated_by && entry.updated_by.name) {
                metaItems.push(t('lastEditedByLabel', 'Last edited by') + ': ' + entry.updated_by.name);
            }
            if (entry.updated_at) {
                metaItems.push(t('lastEdited', 'Last edited:') + ' ' + formatResultDate(entry.updated_at));
            }
            metaItems.push(t('filesCountLabel', 'Files') + ': ' + String(entry.files_count || 0));
            metaItems.forEach(function (textValue) {
                var meta = document.createElement('p');
                meta.className = 'kh-meta';
                meta.textContent = textValue;
                metaList.appendChild(meta);
            });
            body.appendChild(metaList);

            var actions = document.createElement('div');
            actions.className = 'kh-actions';
            var editResultBtn = document.createElement('button');
            editResultBtn.type = 'button';
            editResultBtn.className = 'btn btn-secondary';
            editResultBtn.textContent = t('openResult', 'Open result');
            editResultBtn.addEventListener('click', function () {
                openResultEditor(entry.id);
            });
            actions.appendChild(editResultBtn);
            body.appendChild(actions);

            card.appendChild(body);
            resultsListEl.appendChild(card);
        });
    };

    var renderMethodList = function (methods) {
        methodsCache = Array.isArray(methods) ? methods : [];
        updateCreateResultButtonState();
        if (!methodsListEl) {
            return;
        }
        methodsListEl.innerHTML = '';
        if (!methodsCache.length) {
            var empty = document.createElement('p');
            empty.className = 'kh-meta';
            empty.textContent = t('noMethodsInProject', 'No methods in project.');
            methodsListEl.appendChild(empty);
            return;
        }

        methodsCache.forEach(function (methodItem) {
            var card = document.createElement('div');
            card.className = 'ih-method-item kh-method-card-minimal';

            if (methodItem.image) {
                var image = document.createElement('img');
                image.src = resolveAssetUrl(methodItem.image);
                image.alt = methodItem.title || 'Method image';
                image.className = 'kh-method-card-minimal-image';
                card.appendChild(image);
            }

            var content = document.createElement('div');
            content.className = 'kh-method-card-minimal-body';

            var title = document.createElement('p');
            var strong = document.createElement('strong');
            strong.textContent = methodItem.title || ('Method #' + methodItem.item_id);
            title.appendChild(strong);
            content.appendChild(title);

            var actions = document.createElement('div');
            actions.className = 'kh-actions';
            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'btn btn-delete';
            removeBtn.textContent = t('removeItem', 'Remove item');
            removeBtn.addEventListener('click', function () {
                if (!window.confirm(t('confirmRemoveMethod', 'Remove method from project?'))) {
                    return;
                }
                var removeId = getMethodRecordId(methodItem);
                if (removeId <= 0) {
                    notify('warning', t('couldNotRemoveMethod', 'Could not remove method.'));
                    return;
                }
                api.removeMethod(removeId)
                    .then(function () {
                        removeMethodFromLocalState(removeId);
                        notify('success', t('methodRemovedSuccess', 'Method removed successfully.'));
                        loadResults();
                        syncMethodsAfterRemoval();
                        return Promise.resolve();
                    })
                    .catch(function (error) {
                        handleApiError(error, t('couldNotRemoveMethod', 'Could not remove method.'));
                    });
            });
            actions.appendChild(removeBtn);

            var openMethodButton = document.createElement('button');
            openMethodButton.type = 'button';
            openMethodButton.className = 'btn btn-secondary';
            openMethodButton.textContent = t('openMethodOverview', 'Open method overview');
            openMethodButton.addEventListener('click', function () {
                if (methodEditorBaseUrl && projectId > 0 && methodItem.item_id > 0) {
                    var editorUrl = new URL(methodEditorBaseUrl, window.location.origin);
                    editorUrl.searchParams.set('project_id', String(projectId));
                    editorUrl.searchParams.set('method_id', String(methodItem.item_id));
                    window.location.href = editorUrl.toString();
                    return;
                }
                openMethodEditor(methodItem.item_id);
            });
            actions.appendChild(openMethodButton);

            content.appendChild(actions);
            card.appendChild(content);
            methodsListEl.appendChild(card);
        });
    };

    var renderSearchResults = function (items) {
        if (!contentSearchResultsEl) {
            return;
        }
        contentSearchResultsEl.innerHTML = '';
        if (!items.length) {
            renderSearchHint(t('noMethodsFound', 'No methods found.'));
            return;
        }

        items.forEach(function (hit) {
            var card = document.createElement('div');
            card.className = 'kh-content-item';
            var shortDescription = String(hit.short_description || hit.description_short || '');
            var description = String(hit.description || '');

            var title = document.createElement('strong');
            title.textContent = hit.title;
            card.appendChild(title);

            var meta = document.createElement('small');
            meta.textContent = t('methodIdMetaPrefix', 'METHOD | ID') + ': ' + hit.id;
            card.appendChild(meta);

            if (shortDescription) {
                var shortDesc = document.createElement('p');
                shortDesc.className = 'kh-meta';
                setLimitedHtml(shortDesc, shortDescription);
                card.appendChild(shortDesc);
            }

            if (description) {
                var desc = document.createElement('p');
                desc.className = 'kh-meta';
                setLimitedHtml(desc, description);
                card.appendChild(desc);
            }

            if (hit.image) {
                var image = document.createElement('img');
                image.src = resolveAssetUrl(hit.image);
                image.alt = hit.title || 'Method image';
                image.style.maxWidth = '120px';
                image.style.height = 'auto';
                image.style.borderRadius = '8px';
                image.style.display = 'block';
                image.style.marginBottom = '8px';
                card.appendChild(image);
            }

            var actions = document.createElement('div');
            actions.className = 'kh-actions';
            actions.style.marginTop = '8px';

            var addBtn = document.createElement('button');
            addBtn.type = 'button';
            addBtn.className = 'btn btn-secondary';
            if (hit.already_added === true) {
                addBtn.disabled = true;
                addBtn.textContent = t('alreadyAdded', 'Already added');
            } else {
                addBtn.textContent = t('addToProject', 'Add to project');
                addBtn.addEventListener('click', function () {
                    addBtn.disabled = true;
                    api.addMethod(hit.id)
                        .then(function () {
                            notify('success', t('methodAddedSuccess', 'Method added successfully.'));
                            return Promise.all([loadMethods(), loadDashboardData()]);
                        })
                        .then(function () {
                            if (lastSearchQuery !== '') {
                                return runSearch(lastSearchQuery);
                            }
                            return null;
                        })
                        .catch(function (error) {
                            addBtn.disabled = false;
                            handleApiError(error, t('couldNotAddMethod', 'Could not add method.'));
                        });
                });
            }
            actions.appendChild(addBtn);
            card.appendChild(actions);
            contentSearchResultsEl.appendChild(card);
        });
    };

    var openMethodEditor = function (methodId) {
        if (!methodId) {
            return;
        }
        if (methodEditorBaseUrl && projectId > 0) {
            var editorUrl = new URL(methodEditorBaseUrl, window.location.origin);
            editorUrl.searchParams.set('project_id', String(projectId));
            editorUrl.searchParams.set('method_id', String(methodId));
            window.location.href = editorUrl.toString();
        }
    };

    var saveProjectResult = function () {
        if (!currentResult) {
            return;
        }
        if (!hasAssignedProjectMethods()) {
            setEditorError(t('resultNeedsProjectMethods', 'You can only create results once this project has at least one method.'));
            return;
        }
        if (pendingUploads > 0) {
            setEditorError(t('uploadsInProgress', 'Please wait until file uploads are finished.'));
            return;
        }
        if (typeof syncTemplateBeforeSave === 'function') {
            syncTemplateBeforeSave();
        }
        var selectedMethodIds = getSelectedResultMethodIds();
        ensureTemplateForSelectedMethods(selectedMethodIds)
            .then(function (templateDefinition) {
                if (!currentResult.template_schema && templateDefinition.template_schema) {
                    currentResult.template_schema = templateDefinition.template_schema;
                }
                if (!currentResult.template_type && templateDefinition.template_type) {
                    currentResult.template_type = templateDefinition.template_type;
                }
                if (!currentResult.template_version && templateDefinition.template_version) {
                    currentResult.template_version = templateDefinition.template_version;
                }

                var resultPayload = collectTemplatePayload();
                var nextStatus = normalizeResultStatus(resultStatusEl && resultStatusEl.value ? resultStatusEl.value : 'draft');
                var patch = {
                    title: String(resultTitleEl && resultTitleEl.value ? resultTitleEl.value : '').trim(),
                    short_description: String(resultShortDescriptionEl && resultShortDescriptionEl.value ? resultShortDescriptionEl.value : '').trim(),
                    description: getResultDescriptionHtml(),
                    status: nextStatus,
                    assigned_user_id: parseInt(resultAssignedUserEl && resultAssignedUserEl.value ? resultAssignedUserEl.value : 0, 10) || null,
                    project_method_ids: selectedMethodIds,
                    image_file_id: parseInt(resultImageSelectEl && resultImageSelectEl.value ? resultImageSelectEl.value : 0, 10) || null,
                    template_type: currentResult.template_type || templateDefinition.template_type || '',
                    template_version: currentResult.template_version || templateDefinition.template_version || '1.0',
                    template_schema: currentResult.template_schema || templateDefinition.template_schema || null,
                    payload: resultPayload
                };

                if (nextStatus === 'completed' && !hasMeaningfulResult(patch.title, getResultDescriptionText(), resultPayload)) {
                    setEditorError(t('completedNeedsResult', 'A result is required for completed.'));
                    return;
                }

                setEditorError('');
                clearFieldErrors();
                var request = currentResult.id > 0
                    ? api.updateResult(currentResult.id, patch)
                    : api.createResult(patch);
                return request
                    .then(function (payload) {
                        var normalized = normalizeProjectResult(extractSingle(payload));
                        var resultId = normalized && normalized.id ? normalized.id : currentResult.id;
                        updateEditorStatusChip(nextStatus);
                        editorDirty = false;
                        return Promise.all([loadResults(), loadMethods()]).then(function () {
                            return refreshResultEditor(resultId, true);
                        });
                    })
                    .catch(function (error) {
                        if (error && error.status === 422) {
                            setEditorError(getErrorMessage(error, t('validationFailed', 'Validation failed.')));
                            applyFieldErrors(extractValidationErrors(error));
                            return;
                        }
                        handleApiError(error, t('couldNotSaveResult', 'Could not save result.'));
                    });
            });
    };

    var deleteProjectResult = function () {
        if (!currentResult || !currentResult.id) {
            closeEditor(false);
            return;
        }
        if (!window.confirm(t('confirmDeleteResult', 'Delete result permanently?'))) {
            return;
        }
        api.deleteResult(currentResult.id)
            .then(function (payload) {
                notify('success', buildFlashMessage(payload, t('resultDeleted', 'Result deleted.')));
                closeEditor(false);
                return loadResults();
            })
            .catch(function (error) {
                handleApiError(error, t('couldNotDeleteResult', 'Could not delete result.'));
            });
    };

    var loadMethods = function () {
        if (methodsListEl) {
            methodsListEl.innerHTML = '';
            var loadingState = document.createElement('p');
            loadingState.className = 'kh-meta';
            loadingState.textContent = t('loadingMethods', 'Loading project methods...');
            methodsListEl.appendChild(loadingState);
        }

        return api.listMethods()
            .then(function (payload) {
                var rows = extractRows(payload);
                methodsCache = rows.map(normalizeMethodItem).filter(function (item) { return !!item; });
                updateCreateResultButtonState();
                if (methodsCache.length > 0) {
                    renderMethodList(methodsCache);
                    return;
                }

                return api.listAddedMethodsFromSearch()
                    .then(function (fallbackPayload) {
                        var fallbackRows = extractRows(fallbackPayload).filter(function (row) {
                            return row && row.already_added === true;
                        });
                        methodsCache = fallbackRows.map(normalizeMethodItem).filter(function (item) { return !!item; });
                        updateCreateResultButtonState();
                        renderMethodList(methodsCache);
                    });
            })
            .catch(function (error) {
                updateCreateResultButtonState();
                handleApiError(error, t('couldNotLoadProjectMethods', 'Could not load project methods.'));
            });
    };

    var runSearch = function (query) {
        var trimmed = String(query || '').trim();
        lastSearchQuery = trimmed;
        if (trimmed.length < minSearchChars) {
            renderSearchHint(t('minSearchCharsHint', 'Please enter at least 2 characters.'));
            return Promise.resolve();
        }

        renderSearchHint(t('searching', 'Searching...'));
        return api.searchMethods(trimmed)
            .then(function (payload) {
                var rows = extractRows(payload);
                renderSearchResults(rows);
            })
            .catch(function (error) {
                handleApiError(error, t('searchFailed', 'Search failed. Please try again.'));
            });
    };

    if (contentSearchForm && contentSearchInput && contentSearchResultsEl) {
        renderSearchHint(t('noMethodsFound', 'No methods found.'));
        contentSearchInput.addEventListener('input', function () {
            if (searchTimer) {
                clearTimeout(searchTimer);
            }
            var query = contentSearchInput.value || '';
            searchTimer = setTimeout(function () {
                runSearch(query);
            }, searchDebounceMs);
        });
        contentSearchForm.addEventListener('submit', function (event) {
            event.preventDefault();
            runSearch(contentSearchInput.value || '');
        });
    }

    if (projectSearchInput && projectListEl) {
        if (projectSearchForm) {
            projectSearchForm.addEventListener('submit', function (event) {
                event.preventDefault();
                runProjectSearch(projectSearchInput.value || '');
            });
        }
        projectSearchInput.addEventListener('input', function () {
            if (projectSearchTimer) {
                clearTimeout(projectSearchTimer);
            }
            var value = String(projectSearchInput.value || '');
            projectSearchTimer = setTimeout(function () {
                runProjectSearch(value);
            }, searchDebounceMs);
        });
        renderProjectList(projectsCache);
        ensureProjectsLoaded(false)
            .then(function () {
                return runProjectSearch(projectSearchInput.value || '');
            })
            .catch(function (error) {
                handleApiError(error, t('projectSearchFailed', 'Project search failed.'));
            });
    }
    if (homeProjectListEl) {
        if (projectsLoadedOnce) {
            renderHomeProjectsOverview(projectsCache);
        }
        ensureProjectsLoaded(false)
            .then(function (rows) {
                renderHomeProjectsOverview(rows);
            })
            .catch(function (error) {
                handleApiError(error, t('projectSearchFailed', 'Project search failed.'));
            });
    }
    if (projectFilesFormEl) {
        projectFilesFormEl.addEventListener('submit', function (event) {
            event.preventDefault();
            uploadProjectFileViaApi();
        });
    }
    if (projectFileInputEl) {
        var projectFileDropLabel = projectFileInputEl.closest ? projectFileInputEl.closest('.file-label') : null;
        var updateProjectFileUiState = function (file) {
            var nameEl = document.getElementById('uploaded-file-name');
            if (nameEl) {
                nameEl.textContent = file ? file.name : '';
            }
            projectFileInputEl.classList.toggle('has-file', !!file);
        };
        var setSelectedProjectFile = function (file) {
            if (!file) {
                return;
            }
            var transfer = null;
            try {
                transfer = new DataTransfer();
                transfer.items.add(file);
                projectFileInputEl.files = transfer.files;
            } catch (e) {
                return;
            }
            var nameEl = document.getElementById('uploaded-file-name');
            updateProjectFileUiState(file);
        };
        projectFileInputEl.addEventListener('change', function () {
            var file = this.files && this.files[0] ? this.files[0] : null;
            var nameEl = document.getElementById('uploaded-file-name');
            updateProjectFileUiState(file);
        });
        if (projectFileDropLabel) {
            ['dragenter', 'dragover'].forEach(function (eventName) {
                projectFileDropLabel.addEventListener(eventName, function (event) {
                    event.preventDefault();
                    projectFileDropLabel.classList.add('is-dragover');
                });
            });
            ['dragleave', 'drop'].forEach(function (eventName) {
                projectFileDropLabel.addEventListener(eventName, function (event) {
                    event.preventDefault();
                    projectFileDropLabel.classList.remove('is-dragover');
                });
            });
            projectFileDropLabel.addEventListener('drop', function (event) {
                var files = event.dataTransfer && event.dataTransfer.files ? event.dataTransfer.files : null;
                var file = files && files[0] ? files[0] : null;
                if (!file) {
                    return;
                }
                setSelectedProjectFile(file);
            });
        }
    }
    if (projectFilesTypeFilterEl) {
        projectFilesTypeFilterEl.addEventListener('change', function () {
            renderProjectFiles();
        });
    }

    if (resultStatusEl) resultStatusEl.addEventListener('change', function () { editorDirty = true; });
    if (resultTitleEl) resultTitleEl.addEventListener('input', function () { editorDirty = true; });
    if (resultShortDescriptionEl) resultShortDescriptionEl.addEventListener('input', function () { editorDirty = true; });
    if (resultAssignedUserEl) resultAssignedUserEl.addEventListener('change', function () { editorDirty = true; });
    if (resultMethodsEl) resultMethodsEl.addEventListener('change', function () {
        editorDirty = true;
        if (currentResult && (!currentResult.template_schema || !currentResult.template_type)) {
            var selectedMethodIds = getSelectedResultMethodIds();
            ensureTemplateForSelectedMethods(selectedMethodIds).then(function (templateDefinition) {
                if (templateDefinition.template_schema && !hasMeaningfulValue(formState)) {
                    currentResult.template_type = templateDefinition.template_type || '';
                    currentResult.template_version = templateDefinition.template_version || '1.0';
                    currentResult.template_schema = templateDefinition.template_schema;
                    renderTemplateSections(currentResult.template_schema, currentResult.payload || {});
                }
            });
        }
    });
    if (resultDescriptionEl) resultDescriptionEl.addEventListener('input', function () {
        editorDirty = true;
        syncResultDescriptionPlaceholder();
    });
    if (resultImageSelectEl) resultImageSelectEl.addEventListener('change', function () {
        editorDirty = true;
        renderResultImagePreview(currentResult);
    });
    if (resultDescriptionToolbarEl) {
        resultDescriptionToolbarEl.addEventListener('mousedown', function (event) {
            var button = event.target && event.target.closest ? event.target.closest('[data-command]') : null;
            if (button) {
                event.preventDefault();
            }
        });
        resultDescriptionToolbarEl.addEventListener('click', function (event) {
            var button = event.target && event.target.closest ? event.target.closest('[data-command]') : null;
            if (!button || !resultDescriptionEl) {
                return;
            }
            event.preventDefault();
            resultDescriptionEl.focus();
            var command = String(button.getAttribute('data-command') || '');
            var commandValue = String(button.getAttribute('data-command-value') || '');
            if (command === 'normalText') {
                if (document.queryCommandState && document.queryCommandState('insertUnorderedList')) {
                    document.execCommand('insertUnorderedList', false, null);
                }
                document.execCommand('removeFormat', false, null);
                document.execCommand('formatBlock', false, 'p');
                editorDirty = true;
                window.setTimeout(syncResultDescriptionPlaceholder, 0);
                return;
            }
            if (command) {
                document.execCommand(command, false, commandValue || null);
                editorDirty = true;
                window.setTimeout(syncResultDescriptionPlaceholder, 0);
            }
        });
    }

    syncResultDescriptionPlaceholder();
    if (resultFilesInputEl) {
        resultFilesInputEl.addEventListener('change', function () {
            var files = resultFilesInputEl.files || [];
            if (!files.length) {
                return;
            }
            if (!currentResult || !currentResult.id) {
                notify('warning', t('saveResultBeforeUpload', 'Please save the result once before uploading files.'));
                resultFilesInputEl.value = '';
                return;
            }
            pendingUploads += 1;
            updateSaveButtonsState();
            api.uploadResultFiles(currentResult.id, files)
                .then(function (payload) {
                    notify('success', buildFlashMessage(payload, t('fileUploadSuccess', 'File uploaded and attached.')));
                    return refreshResultEditor(currentResult.id, false);
                })
                .catch(function (error) {
                    handleApiError(error, t('fileUploadFailed', 'File upload failed.'));
                })
                .finally(function () {
                    pendingUploads = Math.max(0, pendingUploads - 1);
                    updateSaveButtonsState();
                    resultFilesInputEl.value = '';
                });
        });
    }
    if (editorCloseBtn) editorCloseBtn.addEventListener('click', function () { closeEditor(true); });
    if (saveBtn) saveBtn.addEventListener('click', saveProjectResult);
    if (resultDeleteBtn) resultDeleteBtn.addEventListener('click', deleteProjectResult);
    if (createResultBtn) createResultBtn.addEventListener('click', openNewResultEditor);
    if (resultsStatusFilterEl) {
        resultsStatusFilterEl.addEventListener('change', function () {
            renderProjectResults(resultsCache);
        });
    }

    window.addEventListener('beforeunload', function (event) {
        if (!editorDirty) {
            return;
        }
        event.preventDefault();
        event.returnValue = '';
    });

    bindProjectActionForms();
    if (createProjectFormEl) {
        createProjectFormEl.addEventListener('submit', function (event) {
            event.preventDefault();
            createProjectViaApi();
        });
    }
    if (projectId > 0) {
        methodsCache = Array.isArray(initialProjectMethods)
            ? initialProjectMethods.map(normalizeMethodItem).filter(function (item) { return !!item; })
            : [];
        renderMethodList(methodsCache);
    }
    updateCreateResultButtonState();
    loadDashboardData();
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initProjectsPage);
    } else {
        initProjectsPage();
    }
})();
